var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _linearGradient44, _linearGradient45, _linearGradient46, _linearGradient47, _linearGradient48, _linearGradient49, _linearGradient50, _linearGradient51, _linearGradient52, _linearGradient53, _linearGradient54, _linearGradient55, _linearGradient56, _linearGradient57, _linearGradient58, _linearGradient59, _linearGradient60, _linearGradient61, _linearGradient62, _linearGradient63, _linearGradient64, _linearGradient65, _linearGradient66, _linearGradient67, _linearGradient68, _linearGradient69, _linearGradient70, _linearGradient71, _linearGradient72, _linearGradient73, _linearGradient74, _linearGradient75, _linearGradient76, _linearGradient77, _linearGradient78, _linearGradient79, _linearGradient80, _linearGradient81, _linearGradient82, _linearGradient83, _linearGradient84, _linearGradient85, _linearGradient86, _linearGradient87, _linearGradient88, _linearGradient89, _linearGradient90, _linearGradient91, _linearGradient92, _linearGradient93, _linearGradient94, _linearGradient95, _linearGradient96, _linearGradient97, _linearGradient98, _linearGradient99, _linearGradient100;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 740 774.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -8073.38,
    y1: -7827.12,
    x2: -8082.3,
    y2: -7903.68,
    gradientTransform: "translate(8191 8258.42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#f8cbca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcee21"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -8050.57,
    y1: -7915.76,
    x2: -8104.93,
    y2: -7821.6,
    gradientTransform: "translate(8191 8258.42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0071bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20142c"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -8056,
    y1: -7893.79,
    x2: -8099.5,
    y2: -7818.46,
    xlinkHref: "#linear-gradient-2"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -8077.75,
    y1: -7824.74,
    x2: -7969.02,
    y2: -7824.74,
    gradientTransform: "translate(8191 8258.42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#20142c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0071bc"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -8073.38,
    y1: -7812.05,
    x2: -8082.3,
    y2: -7888.61,
    gradientTransform: "translate(8191 8212.44)",
    xlinkHref: "#linear-gradient"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -8050.57,
    y1: -7900.69,
    x2: -8104.93,
    y2: -7806.53,
    gradientTransform: "translate(8191 8212.44)",
    xlinkHref: "#linear-gradient-2"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -8056,
    y1: -7878.72,
    x2: -8099.5,
    y2: -7803.39,
    gradientTransform: "translate(8191 8212.44)",
    xlinkHref: "#linear-gradient-2"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -8077.75,
    y1: -7809.67,
    x2: -7969.02,
    y2: -7809.67,
    gradientTransform: "translate(8191 8212.44)",
    xlinkHref: "#linear-gradient-4"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -7834.22,
    y1: -7602.17,
    x2: -7727.57,
    y2: -7602.17,
    gradientTransform: "translate(7840.82 8020.22)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcee21",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fbed21",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#ecdf1f",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#e0d41d",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#d5c91c",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#ccc11b",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#c5bb1a",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#c1b619",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#beb419",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bdb319"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -7727.57,
    y1: -7602.09,
    x2: -7621.2,
    y2: -7602.09,
    gradientTransform: "translate(7840.82 8020.22)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcee21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#fcee21",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#fcee21",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#fcee21",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#fcee21",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#fcee21",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#fcee21",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#fcee21",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#fcee21",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#fcee21",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcee21",
    stopOpacity: 0
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -8073.38,
    y1: -7796.92,
    x2: -8082.3,
    y2: -7873.48,
    gradientTransform: "translate(8191 8166.29)",
    xlinkHref: "#linear-gradient"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -8050.57,
    y1: -7885.57,
    x2: -8104.93,
    y2: -7791.4,
    gradientTransform: "translate(8191 8166.29)",
    xlinkHref: "#linear-gradient-2"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -8056,
    y1: -7863.59,
    x2: -8099.5,
    y2: -7788.26,
    gradientTransform: "translate(8191 8166.29)",
    xlinkHref: "#linear-gradient-2"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -8077.75,
    y1: -7794.54,
    x2: -7969.02,
    y2: -7794.54,
    gradientTransform: "translate(8191 8166.29)",
    xlinkHref: "#linear-gradient-4"
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -7834.23,
    y1: -7587.04,
    x2: -7727.57,
    y2: -7587.04,
    gradientTransform: "translate(7840.82 7974.06)",
    xlinkHref: "#linear-gradient-9"
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -7727.57,
    y1: -7586.96,
    x2: -7621.2,
    y2: -7586.96,
    gradientTransform: "translate(7840.82 7974.06)",
    xlinkHref: "#linear-gradient-10"
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 117.61,
    y1: 338.4,
    x2: 108.7,
    y2: 261.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7931e"
  }))), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 140.43,
    y1: 249.76,
    x2: 86.06,
    y2: 343.92,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 134.99,
    y1: 271.73,
    x2: 91.5,
    y2: 347.06,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 113.25,
    y1: 340.78,
    x2: 221.98,
    y2: 340.78,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 6.59,
    y1: 356.06,
    x2: 113.25,
    y2: 356.06,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-9"
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 113.25,
    y1: 356.14,
    x2: 219.62,
    y2: 356.14,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-10"
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 80.63,
    y1: 152.37,
    x2: 80.63,
    y2: 283.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcee21",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fcee21",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#fcee21",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#fcee21",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fcee21",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#fcee21",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#fcee21",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#fcee21",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcee21"
  }))), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 145.87,
    y1: 150.7,
    x2: 145.87,
    y2: 284.52,
    xlinkHref: "#linear-gradient-23"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.47,270.92l-7.11,4.13a1.89,1.89,0,0,0,.84-1.4l7.11-4.13A1.9,1.9,0,0,1,154.47,270.92Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.24,273.3l7.12-4.14a2,2,0,0,1-.05.36c0,.13-.07.26-.1.39L148.09,274c0-.13.08-.26.11-.39A1.29,1.29,0,0,0,148.24,273.3Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.14,228.58l7.11-4.13a6.78,6.78,0,0,1,.78.54l-7.11,4.13A6.78,6.78,0,0,0,136.14,228.58Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.14,224.86l7.11-4.13a2.86,2.86,0,0,1,.24,1.09L148.38,226A2.91,2.91,0,0,0,148.14,224.86Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.16,224.85l7.11-4.13h0l-7.11,4.13Z",
    style: {
      fill: "none"
    }
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 80.97,
    y1: 201.08,
    x2: 80.2,
    y2: 317.65,
    xlinkHref: "#linear-gradient-23"
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 142.56,
    y1: 200.35,
    x2: 150.28,
    y2: 323.19,
    xlinkHref: "#linear-gradient-23"
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 380.13,
    y1: 480.01,
    x2: 513.94,
    y2: 480.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1b1464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93278f"
  }))), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 404.89,
    y1: 581.07,
    x2: 388.47,
    y2: 440.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f"
  }))), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 212.88,
    y1: 505.87,
    x2: 580.84,
    y2: 505.87,
    xlinkHref: "#linear-gradient-27"
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 413.58,
    y1: 583.12,
    x2: 580.84,
    y2: 583.12,
    xlinkHref: "#linear-gradient-27"
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 380.13,
    y1: 421.19,
    x2: 513.94,
    y2: 421.19,
    xlinkHref: "#linear-gradient-27"
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 404.89,
    y1: 522.24,
    x2: 388.47,
    y2: 381.19,
    xlinkHref: "#linear-gradient-28"
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 212.88,
    y1: 447.05,
    x2: 580.84,
    y2: 447.05,
    xlinkHref: "#linear-gradient-27"
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 413.58,
    y1: 524.3,
    x2: 580.84,
    y2: 524.3,
    xlinkHref: "#linear-gradient-27"
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 216.08,
    y1: 541.16,
    x2: 413.58,
    y2: 541.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#f0f",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#f0f",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#f0f",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f"
  }))), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 413.58,
    y1: 550.94,
    x2: 577.21,
    y2: 550.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#ff95ff",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#ff71ff",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#ff37ff",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f",
    stopOpacity: 0
  }))), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 380.13,
    y1: 362.83,
    x2: 513.94,
    y2: 362.83,
    xlinkHref: "#linear-gradient-27"
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 404.89,
    y1: 463.88,
    x2: 388.47,
    y2: 322.83,
    xlinkHref: "#linear-gradient-28"
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 212.88,
    y1: 388.69,
    x2: 580.84,
    y2: 388.69,
    xlinkHref: "#linear-gradient-27"
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 413.58,
    y1: 465.94,
    x2: 580.84,
    y2: 465.94,
    xlinkHref: "#linear-gradient-27"
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 216.08,
    y1: 482.8,
    x2: 413.58,
    y2: 482.8,
    xlinkHref: "#linear-gradient-35"
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 413.58,
    y1: 492.58,
    x2: 577.21,
    y2: 492.58,
    xlinkHref: "#linear-gradient-36"
  })), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 380.13,
    y1: 305.31,
    x2: 513.94,
    y2: 305.31,
    xlinkHref: "#linear-gradient-27"
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 404.89,
    y1: 406.37,
    x2: 388.47,
    y2: 265.31,
    xlinkHref: "#linear-gradient-28"
  })), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 212.88,
    y1: 331.17,
    x2: 580.84,
    y2: 331.17,
    xlinkHref: "#linear-gradient-27"
  })), _linearGradient46 || (_linearGradient46 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 413.58,
    y1: 408.42,
    x2: 580.84,
    y2: 408.42,
    xlinkHref: "#linear-gradient-27"
  })), _linearGradient47 || (_linearGradient47 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 216.08,
    y1: 425.28,
    x2: 413.58,
    y2: 425.28,
    xlinkHref: "#linear-gradient-35"
  })), _linearGradient48 || (_linearGradient48 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 413.58,
    y1: 435.06,
    x2: 577.21,
    y2: 435.06,
    xlinkHref: "#linear-gradient-36"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "385.69 47.94 535.89 134.66 535.89 279.19 385.69 192.47 385.69 47.94",
    style: {
      fill: "#333"
    }
  })), _linearGradient49 || (_linearGradient49 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: -7560.5,
    y1: -7530.48,
    x2: -7569.41,
    y2: -7607.04,
    xlinkHref: "#linear-gradient"
  })), _linearGradient50 || (_linearGradient50 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: -7537.68,
    y1: -7619.12,
    x2: -7592.05,
    y2: -7524.96,
    xlinkHref: "#linear-gradient-2"
  })), _linearGradient51 || (_linearGradient51 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: -7543.12,
    y1: -7597.15,
    x2: -7586.61,
    y2: -7521.82,
    xlinkHref: "#linear-gradient-2"
  })), _linearGradient52 || (_linearGradient52 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: -7564.87,
    y1: -7528.1,
    x2: -7456.13,
    y2: -7528.1,
    xlinkHref: "#linear-gradient-4"
  })), _linearGradient53 || (_linearGradient53 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: -7560.5,
    y1: -7515.41,
    x2: -7569.41,
    y2: -7591.97,
    gradientTransform: "translate(8191 8212.44)",
    xlinkHref: "#linear-gradient"
  })), _linearGradient54 || (_linearGradient54 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: -7537.68,
    y1: -7604.05,
    x2: -7592.05,
    y2: -7509.89,
    gradientTransform: "translate(8191 8212.44)",
    xlinkHref: "#linear-gradient-2"
  })), _linearGradient55 || (_linearGradient55 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: -7543.12,
    y1: -7582.08,
    x2: -7586.61,
    y2: -7506.75,
    gradientTransform: "translate(8191 8212.44)",
    xlinkHref: "#linear-gradient-2"
  })), _linearGradient56 || (_linearGradient56 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: -7564.87,
    y1: -7513.03,
    x2: -7456.13,
    y2: -7513.03,
    gradientTransform: "translate(8191 8212.44)",
    xlinkHref: "#linear-gradient-4"
  })), _linearGradient57 || (_linearGradient57 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: -8084.28,
    y1: -7746.79,
    x2: -7977.62,
    y2: -7746.79,
    gradientTransform: "translate(8603.76 8461.48)",
    xlinkHref: "#linear-gradient-9"
  })), _linearGradient58 || (_linearGradient58 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: -7977.62,
    y1: -7746.71,
    x2: -7871.25,
    y2: -7746.71,
    gradientTransform: "translate(8603.76 8461.48)",
    xlinkHref: "#linear-gradient-10"
  })), _linearGradient59 || (_linearGradient59 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: -7560.5,
    y1: -7500.28,
    x2: -7569.41,
    y2: -7576.84,
    gradientTransform: "translate(8191 8166.29)",
    xlinkHref: "#linear-gradient"
  })), _linearGradient60 || (_linearGradient60 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: -7537.68,
    y1: -7588.92,
    x2: -7592.05,
    y2: -7494.76,
    gradientTransform: "translate(8191 8166.29)",
    xlinkHref: "#linear-gradient-2"
  })), _linearGradient61 || (_linearGradient61 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: -7543.12,
    y1: -7566.95,
    x2: -7586.61,
    y2: -7491.62,
    gradientTransform: "translate(8191 8166.29)",
    xlinkHref: "#linear-gradient-2"
  })), _linearGradient62 || (_linearGradient62 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: -7564.87,
    y1: -7497.9,
    x2: -7456.13,
    y2: -7497.9,
    gradientTransform: "translate(8191 8166.29)",
    xlinkHref: "#linear-gradient-4"
  })), _linearGradient63 || (_linearGradient63 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: -8084.28,
    y1: -7731.66,
    x2: -7977.62,
    y2: -7731.66,
    gradientTransform: "translate(8603.76 8415.32)",
    xlinkHref: "#linear-gradient-9"
  })), _linearGradient64 || (_linearGradient64 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: -7977.62,
    y1: -7731.58,
    x2: -7871.25,
    y2: -7731.58,
    gradientTransform: "translate(8603.76 8415.32)",
    xlinkHref: "#linear-gradient-10"
  })), _linearGradient65 || (_linearGradient65 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 630.5,
    y1: 635.04,
    x2: 621.59,
    y2: 558.48,
    xlinkHref: "#linear-gradient-17"
  })), _linearGradient66 || (_linearGradient66 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 653.32,
    y1: 546.4,
    x2: 598.95,
    y2: 640.56,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  })), _linearGradient67 || (_linearGradient67 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 647.88,
    y1: 568.37,
    x2: 604.39,
    y2: 643.7,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  })), _linearGradient68 || (_linearGradient68 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 626.13,
    y1: 637.42,
    x2: 734.87,
    y2: 637.42,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  })), _linearGradient69 || (_linearGradient69 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: -8084.28,
    y1: -7716.57,
    x2: -7977.63,
    y2: -7716.57,
    gradientTransform: "translate(8603.76 8369.26)",
    xlinkHref: "#linear-gradient-9"
  })), _linearGradient70 || (_linearGradient70 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: -7977.63,
    y1: -7716.49,
    x2: -7871.25,
    y2: -7716.49,
    gradientTransform: "translate(8603.76 8369.26)",
    xlinkHref: "#linear-gradient-10"
  })), _linearGradient71 || (_linearGradient71 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 593.51,
    y1: 449.01,
    x2: 593.51,
    y2: 580.24,
    xlinkHref: "#linear-gradient-23"
  })), _linearGradient72 || (_linearGradient72 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 658.75,
    y1: 447.34,
    x2: 658.75,
    y2: 581.16,
    xlinkHref: "#linear-gradient-23"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M612.53,505.89l-6.55,3.8a2.24,2.24,0,0,1-2.28-.22,7.13,7.13,0,0,1-3.2-5.32l6.54-3.81a7.1,7.1,0,0,0,3.2,5.32A2.27,2.27,0,0,0,612.53,505.89Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M601.42,501.84,608,498a2.28,2.28,0,0,0-.94,2.06c0,.08,0,.16,0,.24l-6.54,3.81a1.93,1.93,0,0,1,0-.24A2.27,2.27,0,0,1,601.42,501.84Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M625.77,539.63l6.55-3.81c.16.88.55,1.79.69,2.66l-6.55,3.81C626.32,541.42,625.93,540.51,625.77,539.63Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M589.81,483.7l6.55-3.81a9.78,9.78,0,0,1,6.76-1.23l-6.55,3.81A9.78,9.78,0,0,0,589.81,483.7Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M622.41,511.59l-6.55,3.81a2.27,2.27,0,0,1-2.28-.22,7.13,7.13,0,0,1-3.2-5.32l6.55-3.81a7.13,7.13,0,0,0,3.2,5.32A2.24,2.24,0,0,0,622.41,511.59Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M611.31,507.55l6.55-3.81a2.25,2.25,0,0,0-.94,2.07,1.93,1.93,0,0,0,0,.24l-6.55,3.81a2.09,2.09,0,0,1,0-.24A2.25,2.25,0,0,1,611.31,507.55Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M625.13,531l6.54-3.81a29.51,29.51,0,0,0,.65,8.62l-6.55,3.81A29.19,29.19,0,0,1,625.13,531Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M625.33,529.48l6.55-3.81c0,.54-.36.88-.21,1.53L625.13,531C625,530.35,625.3,530,625.33,529.48Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M596.57,482.47l6.55-3.81a17.65,17.65,0,0,1,5.71,1.94l-6.55,3.8A17.38,17.38,0,0,0,596.57,482.47Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M659.06,567.69l-6.55,3.81a1.14,1.14,0,0,0,.4-1.28l6.55-3.8A1.14,1.14,0,0,1,659.06,567.69Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M632.3,517.3l-6.55,3.8a2.26,2.26,0,0,1-2.29-.22,7.12,7.12,0,0,1-3.2-5.32l6.55-3.8a7.1,7.1,0,0,0,3.2,5.31A2.26,2.26,0,0,0,632.3,517.3Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M621.19,513.26l6.55-3.81a2.25,2.25,0,0,0-.94,2.07,2.09,2.09,0,0,0,0,.24l-6.55,3.8c0-.08,0-.16,0-.24A2.23,2.23,0,0,1,621.19,513.26Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M651.18,563.53l6.55-3.81c.46,2.22,1.27,4.5,1.73,6.7l-6.55,3.8C652.45,568,651.64,565.75,651.18,563.53Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M629.44,522.78,636,519a8.94,8.94,0,0,0-4.11,6.7l-6.55,3.81A8.92,8.92,0,0,1,629.44,522.78Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M602.28,484.4l6.55-3.8,21.9,12.63-6.55,3.8Q613.22,490.73,602.28,484.4Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M631.17,525.64l6.55-3.81c2.25-1.31,5.38-1.08,8.58.67l4.79,2.75-6.55,3.81c-1.6-.93-3.2-1.84-4.79-2.75C636.55,524.55,633.42,524.33,631.17,525.64Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M624.18,497l6.55-3.8a36.2,36.2,0,0,1,12.08,12.06l-6.55,3.8A36.2,36.2,0,0,0,624.18,497Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M637.11,510.41l6.55-3.8c2.67,4.74,4.63,10,5,14.53l-6.55,3.8C641.74,520.38,639.78,515.16,637.11,510.41Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M636.26,509.09l6.55-3.8a10.75,10.75,0,0,0,.76,1.14L637,510.24A10.88,10.88,0,0,1,636.26,509.09Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M637,510.24l6.55-3.81a.76.76,0,0,0,.09.18l-6.55,3.8A.56.56,0,0,1,637,510.24Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M668.73,561.77l-6.55,3.81a6.14,6.14,0,0,0,2.06-2c1.34-1.94,1.67-4.78,1.52-8.12l6.55-3.81c.15,3.34-.18,6.18-1.52,8.12A6.14,6.14,0,0,1,668.73,561.77Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M665.67,553.46l6.54-3.81c.07.88.1,1.38.1,2l-6.55,3.81A19.38,19.38,0,0,0,665.67,553.46Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M644.54,529.06l6.55-3.81,3.29,1.9,3.2,1.86,2.14,1.23a23.1,23.1,0,0,1,5.54,4.6,29.94,29.94,0,0,1,7,14.81l-6.54,3.81a30.08,30.08,0,0,0-7-14.82,23.58,23.58,0,0,0-5.54-4.6L651,532.81l-3.2-1.85Z",
    style: {
      fill: "none"
    }
  })), _linearGradient73 || (_linearGradient73 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 593.86,
    y1: 497.72,
    x2: 593.08,
    y2: 614.29,
    xlinkHref: "#linear-gradient-23"
  })), _linearGradient74 || (_linearGradient74 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 655.45,
    y1: 496.99,
    x2: 663.16,
    y2: 619.83,
    xlinkHref: "#linear-gradient-23"
  })), _linearGradient75 || (_linearGradient75 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: -8049.81,
    y1: -7551.17,
    x2: -8058.73,
    y2: -7627.73,
    xlinkHref: "#linear-gradient"
  })), _linearGradient76 || (_linearGradient76 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: -8027,
    y1: -7639.82,
    x2: -8081.36,
    y2: -7545.65,
    xlinkHref: "#linear-gradient-2"
  })), _linearGradient77 || (_linearGradient77 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: -8032.43,
    y1: -7617.84,
    x2: -8075.93,
    y2: -7542.51,
    xlinkHref: "#linear-gradient-2"
  })), _linearGradient78 || (_linearGradient78 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: -8054.18,
    y1: -7548.79,
    x2: -7945.45,
    y2: -7548.79,
    xlinkHref: "#linear-gradient-4"
  })), _linearGradient79 || (_linearGradient79 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: -8049.81,
    y1: -7536.1,
    x2: -8058.73,
    y2: -7612.66,
    gradientTransform: "translate(8191 8212.44)",
    xlinkHref: "#linear-gradient"
  })), _linearGradient80 || (_linearGradient80 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: -8027,
    y1: -7624.75,
    x2: -8081.36,
    y2: -7530.58,
    gradientTransform: "translate(8191 8212.44)",
    xlinkHref: "#linear-gradient-2"
  })), _linearGradient81 || (_linearGradient81 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: -8032.43,
    y1: -7602.77,
    x2: -8075.93,
    y2: -7527.44,
    gradientTransform: "translate(8191 8212.44)",
    xlinkHref: "#linear-gradient-2"
  })), _linearGradient82 || (_linearGradient82 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: -8054.18,
    y1: -7533.72,
    x2: -7945.45,
    y2: -7533.72,
    gradientTransform: "translate(8191 8212.44)",
    xlinkHref: "#linear-gradient-4"
  })), _linearGradient83 || (_linearGradient83 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: -7845.72,
    y1: -7736.7,
    x2: -7739.06,
    y2: -7736.7,
    gradientTransform: "translate(7875.88 8430.7)",
    xlinkHref: "#linear-gradient-9"
  })), _linearGradient84 || (_linearGradient84 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: -7739.06,
    y1: -7736.62,
    x2: -7632.69,
    y2: -7736.62,
    gradientTransform: "translate(7875.88 8430.7)",
    xlinkHref: "#linear-gradient-10"
  })), _linearGradient85 || (_linearGradient85 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: -8049.81,
    y1: -7520.97,
    x2: -8058.73,
    y2: -7597.53,
    gradientTransform: "translate(8191 8166.29)",
    xlinkHref: "#linear-gradient"
  })), _linearGradient86 || (_linearGradient86 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: -8027,
    y1: -7609.62,
    x2: -8081.36,
    y2: -7515.45,
    gradientTransform: "translate(8191 8166.29)",
    xlinkHref: "#linear-gradient-2"
  })), _linearGradient87 || (_linearGradient87 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: -8032.43,
    y1: -7587.65,
    x2: -8075.93,
    y2: -7512.31,
    gradientTransform: "translate(8191 8166.29)",
    xlinkHref: "#linear-gradient-2"
  })), _linearGradient88 || (_linearGradient88 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: -8054.18,
    y1: -7518.59,
    x2: -7945.45,
    y2: -7518.59,
    gradientTransform: "translate(8191 8166.29)",
    xlinkHref: "#linear-gradient-4"
  })), _linearGradient89 || (_linearGradient89 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: -7845.72,
    y1: -7721.58,
    x2: -7739.06,
    y2: -7721.58,
    gradientTransform: "translate(7875.88 8384.54)",
    xlinkHref: "#linear-gradient-9"
  })), _linearGradient90 || (_linearGradient90 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: -7739.06,
    y1: -7721.49,
    x2: -7632.69,
    y2: -7721.49,
    gradientTransform: "translate(7875.88 8384.54)",
    xlinkHref: "#linear-gradient-10"
  })), _linearGradient91 || (_linearGradient91 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 141.19,
    y1: 614.35,
    x2: 132.27,
    y2: 537.79,
    xlinkHref: "#linear-gradient-17"
  })), _linearGradient92 || (_linearGradient92 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 164,
    y1: 525.7,
    x2: 109.64,
    y2: 619.87,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  })), _linearGradient93 || (_linearGradient93 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 158.56,
    y1: 547.68,
    x2: 115.07,
    y2: 623.01,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  })), _linearGradient94 || (_linearGradient94 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 136.82,
    y1: 616.73,
    x2: 245.55,
    y2: 616.73,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  })), _linearGradient95 || (_linearGradient95 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: -7845.72,
    y1: -7706.48,
    x2: -7739.06,
    y2: -7706.48,
    gradientTransform: "translate(7875.88 8338.48)",
    xlinkHref: "#linear-gradient-9"
  })), _linearGradient96 || (_linearGradient96 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: -7739.06,
    y1: -7706.4,
    x2: -7632.69,
    y2: -7706.4,
    gradientTransform: "translate(7875.88 8338.48)",
    xlinkHref: "#linear-gradient-10"
  })), _linearGradient97 || (_linearGradient97 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 104.2,
    y1: 428.31,
    x2: 104.2,
    y2: 559.55,
    xlinkHref: "#linear-gradient-23"
  })), _linearGradient98 || (_linearGradient98 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 169.44,
    y1: 426.65,
    x2: 169.44,
    y2: 560.47,
    xlinkHref: "#linear-gradient-23"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.71,505l10-5.8a2,2,0,0,1,.59-.22c3.17-.69,6.34-1.37,9.52-2,1.29-.26,2.6-.47,3.93-.66a5,5,0,0,1,2.71.46l.31.16-10,5.79a3,3,0,0,0-.31-.15,4.86,4.86,0,0,0-2.71-.46c-1.33.18-2.64.39-3.93.65-3.18.65-6.35,1.34-9.52,2A1.77,1.77,0,0,0,102.71,505Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.35,518.4l10-5.8,22.27-4.83-10,5.79Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.77,502.66l10-5.79a3.36,3.36,0,0,1,1,.91c1.62,2.11,3.26,4.18,4.89,6.27l.31.42-10,5.79-.31-.42c-1.63-2.09-3.27-4.16-4.89-6.27A3.65,3.65,0,0,0,119.77,502.66Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.41,513.21l-10,5.79-.16.09a4.21,4.21,0,0,1-4.07-.3l-.33-.18a14.34,14.34,0,0,1-3-2.39,24.11,24.11,0,0,1-2.29-2.66l10-5.79a25.07,25.07,0,0,0,2.29,2.66,14.28,14.28,0,0,0,3,2.38l.33.19a4.26,4.26,0,0,0,4.07.3Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.91,448.48l10-5.79a1.44,1.44,0,0,1,.4-.18,6.7,6.7,0,0,1,4,.1c.38.11.79.29,1.18.44l-10,5.79c-.39-.14-.79-.33-1.18-.44a6.7,6.7,0,0,0-4-.1A1.81,1.81,0,0,0,145.91,448.48Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.72,530.55l-10,5.79a48.35,48.35,0,0,0,4.14-2.72,78.67,78.67,0,0,0,8.71-7.47,22.24,22.24,0,0,0,3.79-5.28,51.33,51.33,0,0,0,3.68-8.88c.05-.17.11-.33.16-.5l.18-.6c.7-2.32,1.33-4.7,1.83-7.19.42-2.05.79-4.14,1.14-6.25l.12-.73c.29-1.77.49-3.61.71-5.43.18-1.47.32-3,.48-4.44l10-5.79c-.17,1.48-.3,3-.48,4.44-.22,1.82-.42,3.65-.71,5.43l-.12.73c-.35,2.11-.72,4.2-1.14,6.25-.5,2.48-1.13,4.87-1.83,7.18l-.18.61-.16.49a51.9,51.9,0,0,1-3.68,8.89,22.44,22.44,0,0,1-3.79,5.28,79.76,79.76,0,0,1-8.71,7.47C161.52,528.8,160.14,529.72,158.72,530.55Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.77,486.44l10-5.79a2.48,2.48,0,0,0-.08.41l-10,5.79A3,3,0,0,1,173.77,486.44Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.49,448.84l10-5.79,1,.67-10,5.79Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.18,472.44l-10,5.79a.46.46,0,0,0,.17-.34c.13-.77.26-1.53.34-2.33.23-2.41.46-4.81.65-7.24q.7-9.1,1.37-18.24c0-.09,0-.18,0-.27l10-5.8c0,.1,0,.19,0,.28-.46,6.08-.9,12.17-1.37,18.24-.19,2.43-.42,4.83-.65,7.23-.08.8-.21,1.57-.34,2.33C160.32,472.27,160.27,472.39,160.18,472.44Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.53,449.51l10-5.79c.07.1.15.19.23.29l-10,5.8Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.11,451.32l10-5.8a2.13,2.13,0,0,1,.4.24l-10,5.79A3,3,0,0,0,155.11,451.32Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174,483.13l10-5.8c-.07,1.11-.13,2.21-.19,3.32l-10,5.79C173.83,485.33,173.9,484.23,174,483.13Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.52,451.55l10-5.79a53,53,0,0,1,4.53,3.71,51.52,51.52,0,0,1,7.54,8.63,33.57,33.57,0,0,1,6.27,17.48c0,.58.07,1.17.11,1.75l-10,5.8c0-.59-.08-1.18-.11-1.76a33.42,33.42,0,0,0-6.27-17.47,50.74,50.74,0,0,0-7.54-8.63A52.65,52.65,0,0,0,155.52,451.55Z",
    style: {
      fill: "none"
    }
  })), _linearGradient99 || (_linearGradient99 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 104.54,
    y1: 477.02,
    x2: 103.77,
    y2: 593.6,
    xlinkHref: "#linear-gradient-23"
  })), _linearGradient100 || (_linearGradient100 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 166.14,
    y1: 476.29,
    x2: 173.85,
    y2: 599.13,
    xlinkHref: "#linear-gradient-23"
  }))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Support-svg"
  }, /*#__PURE__*/React.createElement("g", {
    className: "block",
    id: "side-block"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bolck"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "48.01 389.74 113.25 352.08 113.25 356.12 48.01 393.79 48.01 389.74",
    style: {
      fill: "#0f1145"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.49 393.79 178.49 389.74 113.25 352.08 113.25 356.12 178.49 393.79",
    style: {
      fill: "#2e3192"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.25 356.12 178.49 393.79 113.44 432.39 48.01 393.79 113.25 356.12",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.25 326.97 4.51 389.74 26.26 402.3 113.25 352.08 200.23 402.3 221.98 389.74 113.25 326.97",
    style: {
      fill: "url(#linear-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.25 452.52 26.26 402.3 48.01 389.74 113.25 427.41 178.49 389.74 200.23 402.3 113.25 452.52",
    style: {
      fill: "url(#linear-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "4.51 414.86 4.51 389.74 113.25 452.52 113.25 477.63 4.51 414.86",
    style: {
      fill: "#20142c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.98 389.74 221.98 414.86 113.25 477.63 113.25 452.52 221.98 389.74",
    style: {
      fill: "url(#linear-gradient-4)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "bolck-2",
    "data-name": "bolck"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "48.01 358.83 113.25 321.17 113.25 325.21 48.01 362.88 48.01 358.83",
    style: {
      fill: "#0f1145"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.49 362.88 178.49 358.83 113.25 321.17 113.25 325.21 178.49 362.88",
    style: {
      fill: "#2e3192"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.25 325.21 178.49 362.88 113.44 401.48 48.01 362.88 113.25 325.21",
    style: {
      fill: "url(#linear-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.25 296.06 4.51 358.83 26.26 371.39 113.25 321.17 200.23 371.39 221.98 358.83 113.25 296.06",
    style: {
      fill: "url(#linear-gradient-6)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.25 421.61 26.26 371.39 48.01 358.83 113.25 396.5 178.49 358.83 200.23 371.39 113.25 421.61",
    style: {
      fill: "url(#linear-gradient-7)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "4.51 383.94 4.51 358.83 113.25 421.61 113.25 446.72 4.51 383.94",
    style: {
      fill: "#20142c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.98 358.83 221.98 383.94 113.25 446.72 113.25 421.61 221.98 358.83",
    style: {
      fill: "url(#linear-gradient-8)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "light",
    id: "light"
  }, /*#__PURE__*/React.createElement("image", {
    width: 227,
    height: 80,
    transform: "translate(0 378.67)",
    xlinkHref: "data:image/png;base64,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",
    style: {
      opacity: 0.75,
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "6.59 389.38 6.59 385.14 113.25 446.72 113.25 450.95 6.59 389.38",
    style: {
      fill: "url(#linear-gradient-9)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.62 385.31 219.62 389.54 113.25 450.95 113.25 446.72 219.62 385.31",
    style: {
      fill: "url(#linear-gradient-10)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bolck-3",
    "data-name": "bolck"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "48.01 327.81 113.25 290.14 113.25 294.18 48.01 331.85 48.01 327.81",
    style: {
      fill: "#0f1145"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.49 331.85 178.49 327.81 113.25 290.14 113.25 294.18 178.49 331.85",
    style: {
      fill: "#2e3192"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.25 294.18 178.49 331.85 113.44 370.45 48.01 331.85 113.25 294.18",
    style: {
      fill: "url(#linear-gradient-11)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.25 265.03 4.51 327.81 26.26 340.36 113.25 290.14 200.23 340.36 221.98 327.81 113.25 265.03",
    style: {
      fill: "url(#linear-gradient-12)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.25 390.58 26.26 340.36 48.01 327.81 113.25 365.47 178.49 327.81 200.23 340.36 113.25 390.58",
    style: {
      fill: "url(#linear-gradient-13)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "4.51 352.92 4.51 327.81 113.25 390.58 113.25 415.69 4.51 352.92",
    style: {
      fill: "#20142c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.98 327.81 221.98 352.92 113.25 415.69 113.25 390.58 221.98 327.81",
    style: {
      fill: "url(#linear-gradient-14)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "light",
    id: "light-2",
    "data-name": "light"
  }, /*#__PURE__*/React.createElement("image", {
    width: 227,
    height: 80,
    transform: "translate(0 347.67)",
    xlinkHref: "data:image/png;base64,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",
    style: {
      opacity: 0.75,
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "6.59 358.35 6.59 354.12 113.25 415.69 113.25 419.93 6.59 358.35",
    style: {
      fill: "url(#linear-gradient-15)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.62 354.28 219.62 358.51 113.25 419.93 113.25 415.69 219.62 354.28",
    style: {
      fill: "url(#linear-gradient-16)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bolck-4",
    "data-name": "bolck"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "48.01 296.84 113.25 259.17 113.25 263.22 48.01 300.88 48.01 296.84",
    style: {
      fill: "#0f1145"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.49 300.88 178.49 296.84 113.25 259.17 113.25 263.22 178.49 300.88",
    style: {
      fill: "#2e3192"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.25 263.22 178.49 300.88 113.44 339.49 48.01 300.88 113.25 263.22",
    style: {
      fill: "url(#linear-gradient-17)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.25 234.06 4.51 296.84 26.26 309.4 113.25 259.17 200.23 309.4 221.98 296.84 113.25 234.06",
    style: {
      fill: "url(#linear-gradient-18)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.25 359.62 26.26 309.4 48.01 296.84 113.25 334.51 178.49 296.84 200.23 309.4 113.25 359.62",
    style: {
      fill: "url(#linear-gradient-19)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "4.51 321.95 4.51 296.84 113.25 359.62 113.25 384.73 4.51 321.95",
    style: {
      fill: "#20142c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.98 296.84 221.98 321.95 113.25 384.73 113.25 359.62 221.98 296.84",
    style: {
      fill: "url(#linear-gradient-20)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "light",
    id: "light-3",
    "data-name": "light"
  }, /*#__PURE__*/React.createElement("image", {
    width: 227,
    height: 80,
    transform: "translate(0 316.67)",
    xlinkHref: "data:image/png;base64,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",
    style: {
      opacity: 0.75,
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "6.59 327.38 6.59 323.15 113.25 384.73 113.25 388.96 6.59 327.38",
    style: {
      fill: "url(#linear-gradient-21)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.62 323.31 219.62 327.55 113.25 388.96 113.25 384.73 219.62 323.31",
    style: {
      fill: "url(#linear-gradient-22)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "glow"
  }, /*#__PURE__*/React.createElement("g", {
    className: "light",
    id: "light-4",
    "data-name": "light"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "48.01 296.84 48.01 171.37 113.25 133.71 113.25 259.17 48.01 296.84",
    style: {
      opacity: 0.4,
      fill: "url(#linear-gradient-23)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.49 296.84 178.49 171.37 113.25 133.71 113.25 259.17 178.49 296.84",
    style: {
      opacity: 0.4,
      fill: "url(#linear-gradient-24)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "float-up-higher",
    id: "floater",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "77.93 184.27 85.04 180.14 89.47 186.96 82.36 191.1 77.93 184.27",
    style: {
      fill: "#cb2929"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.36 191.1 89.47 186.96 96.27 197.42 89.16 201.55 82.36 191.1",
    style: {
      fill: "#cb2929"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.16 201.55 96.27 197.42 102.47 206.97 95.36 211.1 89.16 201.55",
    style: {
      fill: "#cb2929"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.67,201.77l.33.17,7.11-4.13-.33-.17,0,0,0,0-.27-.11h0l-.11,0-7.11,4.14.14.05.3.13Z",
    style: {
      fill: "#b3b3bb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.36 211.1 102.47 206.97 108.3 215.93 101.18 220.07 95.36 211.1",
    style: {
      fill: "#cb2929"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.93,184.27l4.43,6.83,6.8,10.45,6.2,9.56,5.82,9L77.91,233.33l-.16.09a5.78,5.78,0,0,1-.14-.9l.14-47.34A2.78,2.78,0,0,1,77.93,184.27Z",
    style: {
      fill: "#6d1616"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8,194.89l-.07,0-.16-.12a4.19,4.19,0,0,1-.33-.26l-.08-.06-.38-.35a.47.47,0,0,1-.1-.1l-.25-.26-.1-.12-.24-.29-.08-.1-.06-.08-.15-.22-.07-.1-.14-.22-.06-.1-.16-.29v0c-.06-.12-.12-.23-.17-.35h0c0-.1-.09-.21-.13-.31a.49.49,0,0,0,0-.11,1.72,1.72,0,0,0-.07-.21l0-.13c0-.06,0-.13,0-.2s0-.07,0-.11l0-.21s0-.06,0-.09,0-.2,0-.29l-7.11,4.13a2.18,2.18,0,0,0,0,.25.08.08,0,0,0,0,0,.38.38,0,0,0,0,.1s0,.08,0,.12,0,.05,0,.08,0,.08,0,.12,0,.05,0,.08l0,.12,0,.12s0,0,0,0a1.09,1.09,0,0,0,0,.17l0,.1v0c0,.1.07.19.11.29h0l.16.34h0v0l.17.29.06.1.13.22a.61.61,0,0,1,.07.1l.16.23.06.08,0,0,.06.07a2.17,2.17,0,0,0,.24.29l0,.06.06.06.25.27.07.07,0,0c.13.12.25.24.39.35l0,0,.06.05a3.92,3.92,0,0,0,.32.25l.07,0,.1.07.07.05.27.17,0,0,7.12-4.13Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.45 223.56 110.56 219.42 119.14 232.62 112.03 236.75 103.45 223.56",
    style: {
      fill: "#cb2929"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.81,189.88h0a1.57,1.57,0,0,1,0-.23.43.43,0,0,1,0,0,1.42,1.42,0,0,1,.07-.22l0-.08.06-.11,0-.08.08-.1,0-.06.1-.1,0,0a.83.83,0,0,1,.16-.12l-7.11,4.13-.16.12,0,0-.1.1,0,.06-.08.11,0,.07-.06.12,0,0a0,0,0,0,0,0,0,1.42,1.42,0,0,0-.07.22s0,0,0,0h0l0,.23h0v.06c0,.07,0,.13,0,.19h0l7.11-4.13c0-.07,0-.14,0-.2A.13.13,0,0,1,93.81,189.88Z",
    style: {
      fill: "#bfbfbf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,233.71l-.15,0h-.38l-.09,0h-.05l-.1-.05h0l-.13-.07,0,0-.11-.07-.05,0-.11-.09,0,0a1.85,1.85,0,0,1-.14-.14h0l-.13-.14s0,0,0,0a.76.76,0,0,1-.08-.11l0,0-.15-.21L112,236.75a1.91,1.91,0,0,0,.15.21v0l0,0,.09.11,0,0v0l.13.13h0l.15.13h0l0,0,.11.08,0,0h0l.11.08h0l.13.07h0l0,0,.1,0h.05l.09,0h.05l.11,0h.22l.15,0Z",
    style: {
      fill: "#701717"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.38 182.72 89.5 178.58 89.47 186.96 82.36 191.1 82.38 182.72",
    style: {
      fill: "#190f22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,184.31l0,0,4.45-1.55,0,8.38Z",
    style: {
      fill: "#110b18"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.93 184.27 85.04 180.14 89.5 178.58 82.38 182.72 77.93 184.27",
    style: {
      fill: "#110b17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,192.63l.24,0h.32l.2,0h.07l.26.06,0,0,.24.08.06,0,.28.12,0,0,.3.16L97.13,189l-.3-.16,0,0,0,0-.24-.11-.06,0-.11,0-.12,0-.06,0-.23-.06h-.1l-.19,0H95.3l-.24,0h0l-.2,0h0a1.27,1.27,0,0,0-.32.13l-7.11,4.13a1.83,1.83,0,0,1,.35-.14l.2,0Z",
    style: {
      fill: "#b3b3bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.83,186.12l-.07-.05-.17-.12-.33-.25a.27.27,0,0,0-.08-.07l-.38-.35-.09-.1a3.07,3.07,0,0,1-.25-.26l-.11-.12-.24-.29-.07-.09-.06-.08-.16-.23-.07-.1-.14-.22-.06-.1-.16-.29v0c-.06-.11-.11-.23-.16-.34h0a3,3,0,0,1-.12-.32.42.42,0,0,1,0-.1,1.87,1.87,0,0,1-.07-.22l0-.12a1.46,1.46,0,0,1,0-.2l0-.12,0-.2a.31.31,0,0,0,0-.1,2.81,2.81,0,0,1,0-.29,1.15,1.15,0,0,1,0-.19v-.08a1.57,1.57,0,0,1,0-.23s0,0,0-.05l.07-.22a.25.25,0,0,1,0-.07.34.34,0,0,1,.06-.12.25.25,0,0,1,0-.07.76.76,0,0,1,.08-.11l0-.06.09-.09,0,0,.17-.12L87.42,184l-.17.11,0,0-.1.09,0,.07a.86.86,0,0,0-.07.1.56.56,0,0,0,0,.08l-.06.11,0,0a.06.06,0,0,1,0,0,1.42,1.42,0,0,0-.07.22s0,0,0,0h0a1.72,1.72,0,0,0,0,.24h0v.06a1.15,1.15,0,0,0,0,.19h0a2,2,0,0,0,0,.25v0s0,.07,0,.1,0,.08,0,.12,0,.06,0,.09l0,.11s0,.05,0,.08l0,.12a.93.93,0,0,0,0,.13.43.43,0,0,1,0,.05l.06.16,0,.11v0l.12.3h0c.05.11.11.23.17.34h0v0l.16.29.06.09.14.22.07.11.16.22.06.08,0,0,0,.06.24.29a.21.21,0,0,1,0,.06l.06.06.25.27.07.07,0,0a4.14,4.14,0,0,0,.38.35l0,0,.06.05.33.25.06,0,.11.07.06.05.28.17,0,0,7.11-4.13Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.67,183.92h.06l.08,0h.06l.09,0H88l.15,0h.44l.07,0,.12,0,.08,0,.11,0,.08,0,.13,0,.07,0,.13,0,.06,0,.2.08.13.07.07,0,.2.11,7.11-4.13-.2-.11,0,0-.14-.07h0l-.21-.09,0,0-.14-.05h0l0,0-.13,0-.08,0-.11,0h-.07l-.13,0h-.71l-.08,0h-.07l-.08,0-.06,0-.08,0,0,0-.12.06L87.42,184l.12-.07h0A.2.2,0,0,1,87.67,183.92Z",
    style: {
      fill: "#b3b3bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.85,177.34l-.07,0-.16-.12a4.19,4.19,0,0,1-.33-.26l-.08-.06-.38-.35-.1-.1-.25-.26-.1-.12a3.07,3.07,0,0,1-.24-.29l-.08-.1-.06-.08-.15-.22-.07-.11-.14-.21-.06-.1-.16-.29v0c-.06-.12-.12-.23-.17-.35h0c0-.11-.09-.21-.13-.32a.49.49,0,0,0,0-.11c0-.07,0-.14-.07-.21l0-.13c0-.06,0-.13,0-.2s0-.07,0-.11l0-.21a.28.28,0,0,1,0-.09c0-.1,0-.2,0-.29s0-.13,0-.2a.13.13,0,0,1,0-.06v0a1.43,1.43,0,0,1,0-.22.43.43,0,0,1,0-.05,1.42,1.42,0,0,1,.07-.22l0-.08.06-.11,0-.08.08-.1,0-.06.1-.1,0,0a.83.83,0,0,1,.16-.12l-7.11,4.13-.16.12,0,0a.94.94,0,0,0-.1.1l0,.06-.08.11,0,.07-.06.12,0,0a.08.08,0,0,0,0,0,1.42,1.42,0,0,0-.07.22s0,0,0,0h0l0,.23h0v.06c0,.06,0,.12,0,.18h0a2.18,2.18,0,0,0,0,.25.06.06,0,0,0,0,0,.38.38,0,0,0,0,.1.49.49,0,0,0,0,.12s0,.05,0,.08a.5.5,0,0,0,0,.12s0,0,0,.08l0,.12,0,.12s0,0,0,.05a1.09,1.09,0,0,0,0,.17l0,.1v0a1.78,1.78,0,0,0,.12.29h0c.05.11.1.22.16.33h0l0,0a2.69,2.69,0,0,0,.16.29l.06.1.13.22a.61.61,0,0,1,.07.1c0,.08.11.15.16.22l.06.09,0,0,.06.07a2.17,2.17,0,0,0,.24.29l0,.06.06.06a3.07,3.07,0,0,0,.25.26l.07.07,0,0c.13.12.25.24.39.35l0,0,.06.05.32.25.07.05.1.07.07,0,.27.17,0,0,7.11-4.13Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.45,223.56,112,236.75a2.72,2.72,0,0,0,.94.94,1.07,1.07,0,0,0,.94.15l8.62-3.26L146,275.17a1.5,1.5,0,0,1-.68-.19L80.55,237.6a4.94,4.94,0,0,1-.72-.58Z",
    style: {
      fill: "#6d1616"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.53 234.58 129.65 230.44 153.09 271.04 145.97 275.17 122.53 234.58",
    style: {
      fill: "#ca2929"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.91 237.84 121.03 233.71 129.65 230.44 122.53 234.58 113.91 237.84",
    style: {
      fill: "#6b1515"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.29,168.72h.43l.2,0,.2.05.07,0,.27.11.27.14L91.84,165l-.27-.14h0l-.27-.12h0l-.06,0-.2-.05h0l-.18,0h-.25l-.16,0h0l-.13,0-.06,0a.49.49,0,0,0-.18.08l-7.11,4.13.17-.08.07,0Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.61,175.18l.09,0,0,0,.09,0,.06,0h.79l.13,0h.07l.12,0,.07,0,.13,0,.07,0,.14.05.06,0,.2.09.12.06.07,0,.2.11,7.11-4.14-.2-.11-.07,0-.12-.06h0l-.2-.09-.06,0-.14-.06h0l-.06,0-.12,0-.08,0L96,171h-.07l-.13,0h-.07l-.13,0H95l-.09,0h0l-.09,0,0,0-.11.05h0l-7.11,4.13h0l.11-.05Z",
    style: {
      fill: "#b3b3bb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.2,273.65l7.11-4.13,0,.18-7.11,4.14,0-.19",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.17,273.84l7.11-4.14a4,4,0,0,1-.13.41L148,274.24a3.76,3.76,0,0,0,.13-.4",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,274.24l7.11-4.13a1.67,1.67,0,0,1-.68.81l-7.11,4.13a1.72,1.72,0,0,0,.68-.81",
    style: {
      fill: "#8c8c8c"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-2)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "148.24 273.3 155.35 269.17 155.35 269.17 148.24 273.3 148.24 273.3",
    style: {
      fill: "#991f1f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.24,273.3l7.12-4.13a.71.71,0,0,0,0,.14l-7.11,4.14v-.15",
    style: {
      fill: "#8f1d1d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.24,273.45l7.11-4.14a1.55,1.55,0,0,1,0,.21h0l-7.11,4.13h0a1.18,1.18,0,0,0,0-.2",
    style: {
      fill: "#851b1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.2,273.65l7.11-4.13c0,.13-.07.26-.1.39L148.09,274c0-.13.08-.25.11-.39",
    style: {
      fill: "#7a1919"
    }
  })))), /*#__PURE__*/React.createElement("polygon", {
    points: "124.81 233.71 131.92 229.58 137.78 227.36 130.67 231.49 124.81 233.71",
    style: {
      fill: "#6b1515"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.36 211.1 102.47 206.97 137.78 227.36 130.67 231.49 95.36 211.1",
    style: {
      fill: "#dcdcdc"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.67 231.49 137.78 227.36 144.03 224.99 136.92 229.12 130.67 231.49",
    style: {
      fill: "#6b1515"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90 201.94 97.11 197.81 143.25 224.45 136.14 228.58 90 201.94",
    style: {
      fill: "#c1c1ca"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90 199.22 97.11 195.09 143.26 221.73 136.15 225.86 90 199.22",
    style: {
      fill: "#dcdcdc"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.02 193.17 97.13 189.03 143.28 215.67 136.16 219.81 90.02 193.17",
    style: {
      fill: "#c1c1ca"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.03 190.44 97.14 186.31 143.28 212.95 136.17 217.09 90.03 190.44",
    style: {
      fill: "#dcdcdc"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.05 184.39 97.16 180.26 143.3 206.9 136.19 211.03 90.05 184.39",
    style: {
      fill: "#c1c1ca"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.05 181.67 97.17 177.54 143.31 204.18 136.2 208.31 90.05 181.67",
    style: {
      fill: "#dcdcdc"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.07 175.62 97.18 171.48 143.33 198.12 136.21 202.26 90.07 175.62",
    style: {
      fill: "#c1c1ca"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.73 169.09 91.84 164.96 105.67 172.94 98.56 177.07 84.73 169.09",
    style: {
      fill: "#dcdcdc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.09,274c0-.13.08-.26.11-.39a1.67,1.67,0,0,1-2.23,1.52l-23.44-40.59-8.62,3.26a1.1,1.1,0,0,1-.94-.15,2.81,2.81,0,0,1-.94-.94l-8.58-13.19L79.91,237a7.07,7.07,0,0,1-2-3.64l23.27-13.26-5.82-9,35.31,20.38-5.86,2.22Z",
    style: {
      fill: "#898989"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,201.94l46.14,26.64a6.78,6.78,0,0,1,.78.54l-6.25,2.37L95.36,211.11l-6.2-9.56A5.62,5.62,0,0,1,90,201.94Z",
    style: {
      fill: "#78787e"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-3)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.14,228.58l7.11-4.13,0,0-7.11,4.14,0,0",
    style: {
      fill: "#b3b3bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.18,228.61l7.11-4.14.45.29-7.12,4.13c-.14-.1-.29-.19-.44-.28",
    style: {
      fill: "#bebec7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.62,228.89l7.12-4.13.29.23-7.11,4.13-.3-.23",
    style: {
      fill: "#cacad3"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M138.38,226.37l.08,0,.06,0,.09,0,0,0,.12-.06,7.11-4.14a.47.47,0,0,1-.12.07h0l-.09,0h0l-.09,0h-.06l-.09,0h-.05l-.15,0h-.3l-.13,0h-.07l-.13,0-.07,0-.12,0-.08,0-.12,0-.07,0-.14,0-.06,0-.2-.08-.13-.07-.06,0-.2-.11-7.11,4.13.19.11.07,0,.13.07h0l.2.09.06,0,.14,0h0l.05,0,.13,0,.08,0,.11,0h.08l.13,0h.7l.09,0Z",
    style: {
      fill: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.6,220.63h0c0-.08,0-.16,0-.24s0,0,0,0a.28.28,0,0,0,0-.09s0-.08,0-.12,0-.06,0-.09,0-.07,0-.11,0-.06,0-.08l0-.12,0-.13s0,0,0-.05a1,1,0,0,0,0-.16.49.49,0,0,1,0-.11v0l-.12-.3c0-.11-.1-.23-.16-.34h0l0,0-.16-.29-.06-.1-.13-.21-.07-.11c-.06-.07-.11-.15-.16-.22l-.06-.08,0,0-.06-.06a3.15,3.15,0,0,0-.24-.3l0-.05-.06-.06-.25-.27-.07-.07,0,0c-.13-.13-.26-.24-.39-.35l0,0-.06-.05a3.92,3.92,0,0,0-.32-.25l-.07,0-.1-.07-.07,0-.27-.17,0,0-7.12,4.14.32.19.07.05.16.12.33.25.08.07.38.35.1.09.25.27.1.12a2.17,2.17,0,0,1,.24.29l.08.09.06.08.15.23a.61.61,0,0,1,.07.1,1.64,1.64,0,0,1,.14.22l.06.1c.06.09.11.19.16.28v0a2.49,2.49,0,0,1,.16.33h0c0,.11.09.22.13.32l0,.11a1.87,1.87,0,0,1,.07.22.56.56,0,0,1,0,.12c0,.07,0,.13,0,.2a.5.5,0,0,0,0,.12l0,.2s0,.07,0,.1a2.83,2.83,0,0,1,0,.29c0,.06,0,.12,0,.18s0,.05,0,.07v0a1.85,1.85,0,0,1,0,.23s0,0,0,.05a1.29,1.29,0,0,1-.07.21l0,.08-.06.12,0,.07-.07.11,0,.06-.1.09s0,0-.05,0l-.17.12,7.11-4.14.17-.11,0-.05.1-.09.05-.07.08-.1a.59.59,0,0,0,0-.08l.06-.11s0,0,0,0,0,0,0,0a1.42,1.42,0,0,0,.07-.22s0,0,0,0h0a1.72,1.72,0,0,0,0-.24h0a.13.13,0,0,0,0-.06C146.59,220.75,146.6,220.69,146.6,220.63Z",
    style: {
      fill: "#7b7b81"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.92 229.12 144.03 224.99 150.92 222.37 143.81 226.5 136.92 229.12",
    style: {
      fill: "#6b1515"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.4,217.59l.09,0,0,0,.09,0,.05,0,.12-.06h0l7.11-4.13-.12.06,0,0-.08,0-.06,0-.08,0h-.06l-.09,0h-.71l-.13,0h-.07l-.11,0-.08,0-.13,0-.07,0-.13,0-.06,0-.2-.09-.12-.06-.08,0-.2-.11-7.11,4.14.2.1a.2.2,0,0,0,.08,0l.11.06h0l.2.09.06,0,.14.06h0l.05,0,.13,0,.07,0,.12,0h.07l.13,0h.07l.13,0h.06a1.33,1.33,0,0,0,.2,0h.33Z",
    style: {
      fill: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.62,211.85h0a2.18,2.18,0,0,0,0-.25v0s0-.07,0-.1,0-.08,0-.12,0-.06,0-.08l0-.12s0,0,0-.08a.56.56,0,0,0,0-.12l0-.12a.43.43,0,0,0,0,0l-.06-.17,0-.1v0l-.12-.29h0l-.16-.34h0v0l-.16-.29-.06-.1-.14-.22-.07-.1-.16-.23-.06-.08,0,0,0-.07-.24-.29-.05-.06-.06-.06-.25-.27-.06-.07,0,0-.38-.35,0,0-.06-.05-.33-.25-.06,0-.11-.07-.07,0-.27-.17,0,0L136.19,211l.31.2.07,0,.17.12.32.26.09.06.38.35.09.1a3.07,3.07,0,0,1,.25.26l.11.12.24.29a.86.86,0,0,1,.07.1l.06.08.16.22a.36.36,0,0,0,.07.1c0,.08.09.15.13.22a.53.53,0,0,1,.06.1c.06.1.12.19.17.29v0c.06.12.11.23.16.35h0l.12.32a.36.36,0,0,1,0,.11c0,.07.05.14.07.21l0,.12a1.94,1.94,0,0,1,.05.2.5.5,0,0,1,0,.12.76.76,0,0,1,0,.21s0,.06,0,.09,0,.2,0,.29a1.15,1.15,0,0,1,0,.19v.07h0c0,.08,0,.16,0,.23l0,.05a.81.81,0,0,1-.07.22l0,.08-.06.11s0,.05,0,.08l-.08.1,0,.06a.47.47,0,0,1-.1.1l0,0-.17.12h0l7.11-4.13.17-.12,0-.05.09-.09.05-.06a.76.76,0,0,0,.08-.11l.05-.07a.61.61,0,0,0,0-.12.05.05,0,0,0,0,0l0,0,.07-.22a.08.08,0,0,1,0,0h0a1.57,1.57,0,0,0,0-.23v0h0V212A1.15,1.15,0,0,0,146.62,211.85Z",
    style: {
      fill: "#7b7b81"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.19,211c1.84,1.06,3.33,3.28,3.32,4.95s-1.5,2.17-3.34,1.11L90,190.45c-1.84-1.07-3.33-3.28-3.32-5s1.5-2.16,3.34-1.1Z",
    style: {
      fill: "#78787e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.56 177.07 105.67 172.94 134.8 189.76 127.68 193.89 98.56 177.07",
    style: {
      fill: "#dcdcdc"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.56 177.07 113.16 171.98 127.68 193.89 98.56 177.07",
    style: {
      fill: "#110b18"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.43,208.82l.08,0,.06,0,.09,0,0,0,.12-.07,7.11-4.13a.45.45,0,0,1-.12.06l0,0-.09,0h-.05l-.09,0h-.06l-.09,0h0l-.15,0h-.3l-.13,0h-.07l-.13,0-.07,0-.12,0-.08,0-.12,0-.07,0-.14-.05-.06,0a.88.88,0,0,1-.2-.09l-.14-.06-.05,0-.2-.11-7.11,4.13.19.11.06,0,.14.07h0l.2.09.06,0,.14.05h.06l.13.05.08,0,.11,0h.08l.13,0h.5l.15,0h.05l.09,0Z",
    style: {
      fill: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.65,203.08h0c0-.08,0-.16,0-.24h0s0,0,0-.06,0-.13,0-.19h0s0,0,0-.08l0-.18v0a.24.24,0,0,0,0-.08,1.21,1.21,0,0,0-.05-.18.08.08,0,0,0,0,0,.25.25,0,0,0,0-.07l-.06-.17,0-.06s0,0,0-.05,0-.11-.07-.17l0-.07,0,0-.13-.28v0h0a6.71,6.71,0,0,0-.67-1.06l-7.11,4.14a6.71,6.71,0,0,1,.67,1.06l0,0,.13.27a1.17,1.17,0,0,0,0,.11.87.87,0,0,0,.07.17.36.36,0,0,0,0,.11l.06.18,0,.11a1.21,1.21,0,0,1,0,.18l0,.09,0,.19s0,.05,0,.08,0,.13,0,.19a.13.13,0,0,0,0,.06c0,.09,0,.17,0,.25s0,.12,0,.18,0,.05,0,.07v0a1.57,1.57,0,0,1,0,.23s0,0,0,0a1.29,1.29,0,0,1-.07.21l0,.08-.06.12-.05.07a.86.86,0,0,1-.07.1l-.05.07-.1.09,0,.05-.17.11,2.53-1.47,4.59-2.66a.61.61,0,0,0,.16-.12l.05,0,.1-.1.05-.06.08-.1s0-.05,0-.08l.06-.11,0,0v0a1.42,1.42,0,0,0,.07-.22v0h0a1.85,1.85,0,0,0,0-.23v0h0a.17.17,0,0,0,0-.07C146.64,203.2,146.65,203.14,146.65,203.08Z",
    style: {
      fill: "#7b7b81"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.82,202.67l.28.21.16.14.25.23.17.17.2.21a1.46,1.46,0,0,1,.16.19l.18.21.2.26,0,.06a3.87,3.87,0,0,1,.24.37.35.35,0,0,1,.05.08,3.47,3.47,0,0,1,.21.37l0,0,7.11-4.13h0c-.06-.13-.13-.25-.2-.37l-.05-.08c-.08-.13-.16-.25-.25-.37l0-.06-.12-.17-.08-.09-.18-.22-.08-.1-.08-.08-.2-.21-.1-.11-.06-.06-.25-.23-.12-.1a.1.1,0,0,0,0,0l-.27-.22-.13-.09,0,0-.05,0-.35-.22,0,0-.67.39-.65.38-.64.37-.49.29-4,2.32-.67.39a3.34,3.34,0,0,1,.4.25l0,0Z",
    style: {
      fill: "#e8e8f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,201.94a5.62,5.62,0,0,0-.84-.39l-6.8-10.45,0-8.38,0-12.85c0-1.17,1-1.51,2.31-.78l13.83,8,29.12,16.82,13.89,8a4.62,4.62,0,0,1,2.3,3.44l0,12.9,0,8.26-6.89,2.61a6.78,6.78,0,0,0-.78-.54Zm-3.32-7.67c0,1.67,1.48,3.89,3.32,4.95l46.15,26.64c1.84,1.07,3.33.57,3.34-1.1s-1.49-3.89-3.33-4.95L90,193.17c-1.84-1.07-3.33-.57-3.34,1.1m3.39-18.65c-1.84-1.07-3.33-.57-3.34,1.1s1.48,3.89,3.32,4.95l46.15,26.64c1.84,1.06,3.33.57,3.34-1.1s-1.49-3.89-3.33-5L90.07,175.62m0,8.77c-1.84-1.06-3.34-.57-3.34,1.1s1.48,3.89,3.32,4.95l46.14,26.65c1.84,1.06,3.34.56,3.34-1.11s-1.48-3.89-3.32-4.95L90.05,184.39",
    style: {
      fill: "#898989"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.16,219.81,90,193.17c-1.84-1.07-3.33-.57-3.34,1.1s1.48,3.89,3.32,4.95l46.15,26.64c1.84,1.07,3.33.57,3.34-1.1S138,220.87,136.16,219.81Z",
    style: {
      fill: "#78787e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.56 177.07 105.67 172.94 120.27 167.84 113.16 171.98 98.56 177.07",
    style: {
      fill: "#110b17"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.16 171.98 120.27 167.84 134.8 189.76 127.68 193.89 113.16 171.98",
    style: {
      fill: "#20142c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.83 218.25 150.95 214.12 150.92 222.37 143.81 226.5 143.83 218.25",
    style: {
      fill: "#c5c5c5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.38 225.96 155.49 221.82 155.35 269.17 148.24 273.3 148.38 225.96",
    style: {
      fill: "#9d2020"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.81 226.5 150.92 222.37 155.25 220.73 148.14 224.86 143.81 226.5",
    style: {
      fill: "#6b1515"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-4)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.14,224.86l7.11-4.13a.61.61,0,0,1,.05.12L148.19,225l-.05-.12",
    style: {
      fill: "#cc2929"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.19,225l7.11-4.13.07.19-7.12,4.13-.06-.19",
    style: {
      fill: "#c22727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.25,225.17l7.12-4.13,0,.2-7.11,4.13-.06-.2",
    style: {
      fill: "#b82525"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.31,225.37l7.11-4.13a1.42,1.42,0,0,1,0,.2l-7.11,4.13c0-.06,0-.13,0-.2",
    style: {
      fill: "#ad2323"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.35,225.57l7.11-4.13a1.36,1.36,0,0,1,0,.2l-7.11,4.13a1.36,1.36,0,0,0,0-.2",
    style: {
      fill: "#a32121"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.37,225.77l7.11-4.13a1.09,1.09,0,0,1,0,.18L148.38,226a1.15,1.15,0,0,0,0-.19",
    style: {
      fill: "#991f1f"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M148.14,224.86a2.91,2.91,0,0,1,.24,1.1l-.14,47.34a1.29,1.29,0,0,1,0,.35c0,.13-.07.26-.11.39l-23.28-40.33,5.86-2.22,6.25-2.37,6.89-2.61Z",
    style: {
      fill: "#6d1616"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-5)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.16,224.85l7.11-4.13h0l-7.11,4.13h0",
    style: {
      fill: "#120b18"
    }
  })))), /*#__PURE__*/React.createElement("polygon", {
    points: "143.84 218.25 150.95 214.12 155.31 220.71 148.2 224.84 143.84 218.25",
    style: {
      fill: "#20142c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.83,218.25l4.37,6.59s0,0-.06,0l-4.33,1.65Z",
    style: {
      fill: "#110b18"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.05,181.67c-1.84-1.06-3.32-3.28-3.32-4.95s1.5-2.17,3.34-1.1l46.14,26.64c1.84,1.06,3.33,3.27,3.33,5s-1.5,2.16-3.34,1.1Z",
    style: {
      fill: "#78787e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.68 193.89 134.8 189.76 148.68 197.77 141.57 201.91 127.68 193.89",
    style: {
      fill: "#dcdcdc"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.87 205.35 150.98 201.21 150.95 214.12 143.83 218.25 143.87 205.35",
    style: {
      fill: "#c5c5c5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,202.16a1.84,1.84,0,0,1,.22.17l.06,0a3,3,0,0,1,.26.24l.07.06.17.19.08.08.16.2.05.06.22.32,0,.07.19.34h0v0a1.47,1.47,0,0,1,.1.22v0l.08.2,0,.08,0,.15s0,.06,0,.08,0,.1,0,.14,0,.06,0,.08a.77.77,0,0,1,0,.15.13.13,0,0,1,0,.06,1.48,1.48,0,0,1,0,.21l7.11-4.14V201a.2.2,0,0,0,0-.07.25.25,0,0,0,0-.08.13.13,0,0,0,0-.06s0-.05,0-.08a.13.13,0,0,1,0-.06l0-.08a.29.29,0,0,0,0-.09v0a.36.36,0,0,0,0-.11l0-.08v0l-.07-.18v0h0l-.1-.22h0a3.72,3.72,0,0,0-.19-.34l-.05-.07a3.62,3.62,0,0,0-.22-.32v0l0,0-.16-.2a.08.08,0,0,0,0,0,.08.08,0,0,0,0,0,1.54,1.54,0,0,0-.17-.19l0-.05h0a2.91,2.91,0,0,0-.27-.24v0l-.05,0-.22-.18,0,0,0,0-.22-.14,0,0,0,0-7.11,4.14.07,0,.23.15Z",
    style: {
      fill: "#bfbfbf"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "light",
    id: "light-5",
    "data-name": "light"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "48.01 171.37 113.25 209.39 113.25 334.51 48.01 296.84 48.01 171.37",
    style: {
      opacity: 0.4,
      fill: "url(#linear-gradient-25)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.49 296.84 113.25 334.51 113.25 209.39 178.49 171.37 178.49 296.84",
    style: {
      opacity: 0.4,
      fill: "url(#linear-gradient-26)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    className: "block",
    id: "main-block"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bolck-5",
    "data-name": "bolck"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "279.78 496.21 380.13 438.27 380.13 444.5 279.78 502.44 279.78 496.21",
    style: {
      fill: "#1b1464"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "513.94 521.75 513.94 515.52 380.13 438.27 380.13 444.5 513.94 521.75",
    style: {
      fill: "url(#linear-gradient-27)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.13 444.5 513.94 521.75 413.88 581.12 279.78 502.44 380.13 444.5",
    style: {
      fill: "url(#linear-gradient-28)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.13 399.65 212.88 496.21 246.33 515.52 380.13 438.27 513.94 515.52 413.58 573.46 279.78 496.21 246.33 515.52 413.58 612.09 547.39 534.84 580.84 515.52 380.13 399.65",
    style: {
      fill: "url(#linear-gradient-29)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.88 534.84 212.88 496.21 413.58 612.09 413.58 650.72 212.88 534.84",
    style: {
      fill: "#1b1464"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "580.84 515.52 580.84 554.15 413.58 650.72 413.58 612.09 580.84 515.52",
    style: {
      fill: "url(#linear-gradient-30)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "bolck-6",
    "data-name": "bolck"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "279.78 437.39 380.13 379.45 380.13 385.67 279.78 443.61 279.78 437.39",
    style: {
      fill: "#1b1464"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "513.94 462.92 513.94 456.7 380.13 379.45 380.13 385.67 513.94 462.92",
    style: {
      fill: "url(#linear-gradient-31)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.13 385.67 513.94 462.92 413.88 522.3 279.78 443.61 380.13 385.67",
    style: {
      fill: "url(#linear-gradient-32)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.13 340.83 212.88 437.39 246.33 456.7 380.13 379.45 513.94 456.7 413.58 514.64 279.78 437.39 246.33 456.7 413.58 553.27 547.39 476.01 580.84 456.7 380.13 340.83",
    style: {
      fill: "url(#linear-gradient-33)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.88 476.01 212.88 437.39 413.58 553.27 413.58 591.89 212.88 476.01",
    style: {
      fill: "#1b1464"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "580.84 456.7 580.84 495.33 413.58 591.89 413.58 553.27 580.84 456.7",
    style: {
      fill: "url(#linear-gradient-34)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "light",
    id: "light-6",
    "data-name": "light"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "216.08 490.42 216.08 477.86 413.58 591.89 413.58 604.45 216.08 490.42",
    style: {
      fill: "url(#linear-gradient-35)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "577.21 497.43 577.21 509.99 413.58 604.45 413.58 591.89 577.21 497.43",
    style: {
      fill: "url(#linear-gradient-36)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bolck-7",
    "data-name": "bolck"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "279.78 379.03 380.13 321.09 380.13 327.31 279.78 385.25 279.78 379.03",
    style: {
      fill: "#1b1464"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "513.94 404.56 513.94 398.34 380.13 321.09 380.13 327.31 513.94 404.56",
    style: {
      fill: "url(#linear-gradient-37)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.13 327.31 513.94 404.56 413.88 463.94 279.78 385.25 380.13 327.31",
    style: {
      fill: "url(#linear-gradient-38)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.13 282.46 212.88 379.03 246.33 398.34 380.13 321.09 513.94 398.34 413.58 456.28 279.78 379.03 246.33 398.34 413.58 494.91 547.39 417.65 580.84 398.34 380.13 282.46",
    style: {
      fill: "url(#linear-gradient-39)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.88 417.65 212.88 379.03 413.58 494.91 413.58 533.53 212.88 417.65",
    style: {
      fill: "#1b1464"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "580.84 398.34 580.84 436.97 413.58 533.53 413.58 494.91 580.84 398.34",
    style: {
      fill: "url(#linear-gradient-40)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "light",
    id: "light-7",
    "data-name": "light"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "216.08 432.06 216.08 419.5 413.58 533.53 413.58 546.09 216.08 432.06",
    style: {
      fill: "url(#linear-gradient-41)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "577.21 439.06 577.21 451.62 413.58 546.09 413.58 533.53 577.21 439.06",
    style: {
      fill: "url(#linear-gradient-42)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bolck-8",
    "data-name": "bolck"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "279.78 321.51 380.13 263.57 380.13 269.8 279.78 327.74 279.78 321.51",
    style: {
      fill: "#1b1464"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "513.94 347.05 513.94 340.83 380.13 263.57 380.13 269.8 513.94 347.05",
    style: {
      fill: "url(#linear-gradient-43)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.13 269.8 513.94 347.05 413.88 406.42 279.78 327.74 380.13 269.8",
    style: {
      fill: "url(#linear-gradient-44)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.13 224.95 212.88 321.51 246.33 340.83 380.13 263.57 513.94 340.83 413.58 398.76 279.78 321.51 246.33 340.83 413.58 437.39 547.39 360.14 580.84 340.83 380.13 224.95",
    style: {
      fill: "url(#linear-gradient-45)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.88 360.14 212.88 321.51 413.58 437.39 413.58 476.01 212.88 360.14",
    style: {
      fill: "#1b1464"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "580.84 340.83 580.84 379.45 413.58 476.01 413.58 437.39 580.84 340.83",
    style: {
      fill: "url(#linear-gradient-46)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "light",
    id: "light-8",
    "data-name": "light"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "216.08 374.54 216.08 361.98 413.58 476.01 413.58 488.58 216.08 374.54",
    style: {
      fill: "url(#linear-gradient-47)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "577.21 381.55 577.21 394.11 413.58 488.58 413.58 476.01 577.21 381.55",
    style: {
      fill: "url(#linear-gradient-48)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "laptop",
    id: "laptop"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "385.69 47.94 535.89 134.66 535.89 279.19 385.69 192.47 385.69 47.94",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-6)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.24
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "650.97 212.16 525.81 284.42 375.61 197.71 500.78 125.44 650.97 212.16",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Kaps"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M525.31,261.26l4.65,2.68c.43.25.37.67-.12,1l-1.3.75a1.85,1.85,0,0,1-1.65.07L522.24,263c-.43-.24-.37-.67.12-.95l1.3-.76A1.82,1.82,0,0,1,525.31,261.26Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.84,252.33,514.5,255c.42.24.37.67-.12.95l-1.3.75a1.85,1.85,0,0,1-1.65.07l-4.66-2.69c-.42-.24-.37-.67.12-.95l1.3-.75A1.79,1.79,0,0,1,509.84,252.33Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.57,247l4.65,2.69c.42.24.37.67-.12,1l-1.3.75a1.82,1.82,0,0,1-1.65.07l-4.65-2.69c-.43-.24-.37-.67.11-1l1.31-.75A1.85,1.85,0,0,1,500.57,247Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.29,241.61l4.65,2.69c.42.25.37.67-.12.95l-1.3.76a1.82,1.82,0,0,1-1.65.06l-4.65-2.68c-.43-.25-.37-.67.12-1l1.3-.75A1.85,1.85,0,0,1,491.29,241.61Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482,236.26l4.65,2.68c.43.25.37.68-.12,1l-1.3.75a1.85,1.85,0,0,1-1.65.07L478.94,238c-.42-.24-.37-.67.12-.95l1.3-.75A1.79,1.79,0,0,1,482,236.26Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.52,207.69l4.66,2.68c.42.25.37.68-.12,1l-1.3.75a1.85,1.85,0,0,1-1.65.07l-4.66-2.69c-.42-.24-.37-.67.12-1l1.3-.75A1.79,1.79,0,0,1,432.52,207.69Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.25,202.33,427.9,205c.42.24.37.67-.12.95l-1.3.75a1.85,1.85,0,0,1-1.65.07l-4.65-2.69c-.43-.24-.37-.67.11-.95l1.31-.75A1.85,1.85,0,0,1,423.25,202.33Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414,197l4.65,2.69c.42.25.37.67-.12,1l-1.3.76a1.82,1.82,0,0,1-1.65.06l-4.65-2.68c-.43-.25-.37-.67.12-1l1.3-.75A1.85,1.85,0,0,1,414,197Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.82,256.11l4.06,2.34c.58.34.51.94-.17,1.33L535,261.9a2.54,2.54,0,0,1-2.3.1l-4.05-2.34c-.59-.34-.52-.94.16-1.33l3.69-2.12A2.52,2.52,0,0,1,534.82,256.11Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.54,250.75l4.06,2.35c.58.34.51.93-.17,1.32l-3.68,2.13a2.55,2.55,0,0,1-2.29.09l-4.06-2.34c-.59-.34-.52-.93.16-1.32l3.69-2.13A2.55,2.55,0,0,1,525.54,250.75Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.66,243.65l4.06,2.34c.58.34.51.93-.17,1.33l-3.68,2.12a2.57,2.57,0,0,1-2.3.1l-4.05-2.34c-.59-.34-.52-.94.16-1.33l3.69-2.13A2.54,2.54,0,0,1,531.66,243.65Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.38,238.29l4.06,2.35c.58.34.51.93-.17,1.32l-3.68,2.13a2.55,2.55,0,0,1-2.29.09l-4.06-2.34c-.59-.34-.52-.93.16-1.33l3.69-2.12A2.55,2.55,0,0,1,522.38,238.29Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.1,232.94l4.06,2.34c.59.34.51.93-.17,1.32l-3.68,2.13a2.54,2.54,0,0,1-2.29.09L507,236.48c-.59-.34-.51-.93.16-1.32l3.69-2.13A2.54,2.54,0,0,1,513.1,232.94Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.82,227.58l4.06,2.34c.59.34.51.93-.16,1.33L504,233.37a2.55,2.55,0,0,1-2.29.1l-4.06-2.35c-.59-.33-.51-.93.17-1.32l3.68-2.13A2.54,2.54,0,0,1,503.82,227.58Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.54,222.22l4.06,2.35c.59.33.52.93-.16,1.32L494.75,228a2.54,2.54,0,0,1-2.29.09l-4.06-2.34c-.58-.34-.51-.93.17-1.33l3.68-2.12A2.55,2.55,0,0,1,494.54,222.22Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.27,216.87l4.05,2.34c.59.34.52.93-.16,1.32l-3.69,2.13a2.54,2.54,0,0,1-2.29.09l-4.06-2.34c-.58-.34-.51-.93.17-1.32L483,217A2.57,2.57,0,0,1,485.27,216.87Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476,211.51l4.05,2.34c.59.34.52.93-.16,1.32l-3.68,2.13a2.57,2.57,0,0,1-2.3.1l-4-2.35c-.59-.34-.52-.93.16-1.32l3.68-2.13A2.57,2.57,0,0,1,476,211.51Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.71,206.15l4.06,2.34c.58.34.51.94-.17,1.33l-3.68,2.12a2.52,2.52,0,0,1-2.29.1l-4.06-2.34c-.59-.34-.52-.93.16-1.33l3.69-2.12A2.55,2.55,0,0,1,466.71,206.15Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.43,200.79l4.06,2.35c.59.34.51.93-.17,1.32l-3.68,2.13a2.55,2.55,0,0,1-2.29.09l-4.06-2.34c-.59-.34-.51-.93.16-1.32l3.69-2.13A2.58,2.58,0,0,1,457.43,200.79Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.15,195.44l4.06,2.34c.59.34.51.93-.16,1.32l-3.69,2.13a2.55,2.55,0,0,1-2.29.1L442,199c-.59-.34-.51-.93.17-1.32l3.68-2.13A2.54,2.54,0,0,1,448.15,195.44Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.87,190.08l4.06,2.34c.59.34.52.94-.16,1.33l-3.69,2.12a2.52,2.52,0,0,1-2.29.1l-4.06-2.34c-.59-.34-.51-.94.17-1.33l3.68-2.12A2.52,2.52,0,0,1,438.87,190.08Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.26,245.4l4.06,2.34c.59.34.51.93-.17,1.32l-3.68,2.13a2.58,2.58,0,0,1-2.29.1l-4.06-2.35c-.59-.34-.51-.93.16-1.32l3.69-2.13A2.54,2.54,0,0,1,516.26,245.4Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507,240l4.06,2.34c.59.34.51.93-.16,1.33l-3.69,2.12a2.55,2.55,0,0,1-2.29.1l-4.06-2.34c-.59-.34-.51-.94.17-1.33l3.68-2.13A2.54,2.54,0,0,1,507,240Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.7,234.68l4.06,2.35c.59.34.52.93-.16,1.32l-3.69,2.13a2.54,2.54,0,0,1-2.29.09l-4.06-2.34c-.58-.34-.51-.93.17-1.33l3.68-2.12A2.55,2.55,0,0,1,497.7,234.68Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.43,229.33l4.05,2.34c.59.34.52.93-.16,1.32l-3.69,2.13a2.54,2.54,0,0,1-2.29.09l-4.06-2.34c-.58-.34-.51-.93.17-1.32l3.68-2.13A2.57,2.57,0,0,1,488.43,229.33Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.15,224l4.05,2.34c.59.34.52.93-.16,1.33l-3.68,2.12a2.57,2.57,0,0,1-2.3.1L473,227.51c-.59-.33-.52-.93.16-1.32l3.68-2.13A2.57,2.57,0,0,1,479.15,224Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.87,218.61l4.06,2.35c.58.33.51.93-.17,1.32l-3.68,2.13a2.55,2.55,0,0,1-2.29.09l-4.06-2.34c-.59-.34-.52-.93.16-1.33l3.69-2.12A2.55,2.55,0,0,1,469.87,218.61Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.59,213.26l4.06,2.34c.59.34.51.93-.17,1.32l-3.68,2.13a2.55,2.55,0,0,1-2.29.09l-4.06-2.34c-.59-.34-.51-.93.16-1.32l3.69-2.13A2.54,2.54,0,0,1,460.59,213.26Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.31,207.9l4.06,2.34c.59.34.51.93-.16,1.32l-3.69,2.13a2.55,2.55,0,0,1-2.29.1l-4.06-2.35c-.59-.34-.51-.93.17-1.32L449,208A2.54,2.54,0,0,1,451.31,207.9Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442,202.54l4.06,2.34c.59.34.52.94-.16,1.33l-3.69,2.12a2.52,2.52,0,0,1-2.29.1l-4.06-2.34c-.59-.34-.51-.93.17-1.33l3.68-2.12A2.52,2.52,0,0,1,442,202.54Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.75,197.18l4.06,2.35c.59.34.52.93-.16,1.32L433,203a2.54,2.54,0,0,1-2.29.09l-4.06-2.34c-.58-.34-.51-.93.17-1.32l3.68-2.13A2.58,2.58,0,0,1,432.75,197.18Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.48,191.83l4,2.34c.59.34.52.93-.16,1.32l-3.68,2.13a2.57,2.57,0,0,1-2.3.1l-4.05-2.35c-.59-.34-.52-.93.16-1.32l3.68-2.13A2.57,2.57,0,0,1,423.48,191.83Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541,249l7,4.06c.62.36.54,1-.18,1.4l-3.54,2.05a2.75,2.75,0,0,1-2.43.1l-7-4.06c-.63-.36-.55-1,.17-1.4l3.54-2.05A2.72,2.72,0,0,1,541,249Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.57,186.44l1.2.7c.53.3.46.82-.14,1.17l-4,2.29a2.25,2.25,0,0,1-2,.08l-1.21-.7c-.52-.3-.45-.82.15-1.17l4-2.29A2.28,2.28,0,0,1,432.57,186.44Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.87,238.33l4.06,2.34c.58.34.51.94-.17,1.33l-3.68,2.13a2.55,2.55,0,0,1-2.29.09l-4.06-2.34c-.59-.34-.52-.93.16-1.33l3.69-2.12A2.55,2.55,0,0,1,540.87,238.33Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547,231.23l4,2.34c.59.34.52.93-.16,1.32L547.2,237a2.57,2.57,0,0,1-2.3.1l-4-2.35c-.59-.34-.52-.93.16-1.32l3.68-2.13A2.57,2.57,0,0,1,547,231.23Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.38,229.48l4.06,2.34c.59.34.52.94-.16,1.33l-3.69,2.12a2.52,2.52,0,0,1-2.29.1L556.24,233c-.58-.34-.51-.94.17-1.33l3.68-2.12A2.52,2.52,0,0,1,562.38,229.48Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.11,224.12l4,2.35c.59.34.52.93-.16,1.32l-3.69,2.13A2.54,2.54,0,0,1,551,230L547,227.67c-.58-.34-.51-.93.17-1.32l3.68-2.13A2.6,2.6,0,0,1,553.11,224.12Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.07,195.81l43.37,25c.83.48.73,1.33-.24,1.88l-2.65,1.53a3.6,3.6,0,0,1-3.25.14l-43.37-25c-.84-.48-.73-1.33.23-1.88l2.65-1.53A3.62,3.62,0,0,1,504.07,195.81Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.66,234.84l4.06,2.34c.59.34.51.93-.16,1.32l-3.69,2.13a2.55,2.55,0,0,1-2.29.1l-4.06-2.35c-.59-.34-.51-.93.17-1.32l3.68-2.13A2.54,2.54,0,0,1,571.66,234.84Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.71,225.87l4.06,2.34c.58.34.51.94-.17,1.33l-3.68,2.12a2.52,2.52,0,0,1-2.29.1l-4.06-2.34c-.59-.34-.52-.94.16-1.33l3.69-2.12A2.52,2.52,0,0,1,537.71,225.87Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.43,220.51l4.06,2.35c.59.34.51.93-.17,1.32l-3.68,2.13a2.55,2.55,0,0,1-2.29.09l-4.06-2.34c-.59-.34-.51-.93.16-1.32l3.69-2.13A2.58,2.58,0,0,1,528.43,220.51Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.15,215.16l4.06,2.34c.59.34.51.93-.16,1.32L519.36,221a2.58,2.58,0,0,1-2.29.1L513,218.7c-.59-.34-.51-.93.17-1.32l3.68-2.13A2.54,2.54,0,0,1,519.15,215.16Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.87,209.8l4.06,2.34c.59.34.52.94-.16,1.33l-3.69,2.12a2.52,2.52,0,0,1-2.29.1l-4.06-2.34c-.58-.34-.51-.94.17-1.33l3.68-2.12A2.52,2.52,0,0,1,509.87,209.8Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.59,204.44l4.06,2.35c.59.34.52.93-.16,1.32l-3.69,2.13a2.54,2.54,0,0,1-2.29.09L494.45,208c-.58-.34-.51-.93.17-1.32l3.68-2.13A2.55,2.55,0,0,1,500.59,204.44Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.32,199.09l4.05,2.34c.59.34.52.93-.16,1.32l-3.68,2.13a2.6,2.6,0,0,1-2.3.1l-4.05-2.35c-.59-.34-.52-.93.16-1.32l3.68-2.13A2.57,2.57,0,0,1,491.32,199.09Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482,193.73l4.06,2.34c.58.34.51.93-.17,1.33l-3.68,2.12a2.55,2.55,0,0,1-2.29.1l-4.06-2.34c-.59-.34-.52-.94.16-1.33l3.69-2.13A2.54,2.54,0,0,1,482,193.73Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.39,181.23l4.06,2.34c.58.34.51.94-.17,1.33L460.6,187a2.52,2.52,0,0,1-2.29.1l-4.06-2.34c-.59-.34-.52-.94.16-1.33l3.69-2.12A2.52,2.52,0,0,1,460.39,181.23Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.32,170.56l4.06,2.34c.59.34.51.93-.17,1.32l-3.68,2.13a2.54,2.54,0,0,1-2.29.09l-4.06-2.34c-.59-.34-.51-.93.17-1.32l3.68-2.13A2.54,2.54,0,0,1,460.32,170.56Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.6,175.91l4.06,2.35c.59.33.51.93-.17,1.32l-3.68,2.13a2.55,2.55,0,0,1-2.29.09l-4.06-2.34c-.59-.34-.51-.93.16-1.33l3.69-2.12A2.55,2.55,0,0,1,469.6,175.91Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.88,181.27l4.06,2.34c.58.34.51.93-.17,1.33l-3.68,2.12a2.55,2.55,0,0,1-2.29.1l-4.06-2.35c-.59-.33-.52-.93.16-1.32l3.69-2.13A2.54,2.54,0,0,1,478.88,181.27Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.59,233l4.06,2.35c.59.34.51.93-.17,1.32l-3.68,2.13a2.55,2.55,0,0,1-2.29.09l-4.06-2.34c-.59-.34-.51-.93.16-1.32l3.69-2.13A2.58,2.58,0,0,1,531.59,233Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.31,227.62l4.06,2.34c.59.34.51.93-.16,1.32l-3.69,2.13a2.55,2.55,0,0,1-2.29.1l-4.06-2.35c-.59-.34-.51-.93.17-1.32l3.68-2.13A2.54,2.54,0,0,1,522.31,227.62Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513,222.26l4.06,2.34c.59.34.52.94-.16,1.33l-3.69,2.12a2.52,2.52,0,0,1-2.29.1l-4.06-2.34c-.59-.34-.51-.94.17-1.33l3.68-2.12A2.52,2.52,0,0,1,513,222.26Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.75,216.9l4.06,2.35c.59.34.52.93-.16,1.32L504,222.7a2.54,2.54,0,0,1-2.29.09l-4.06-2.34c-.58-.34-.51-.93.17-1.32l3.68-2.13A2.58,2.58,0,0,1,503.75,216.9Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.48,211.55l4,2.34c.59.34.52.93-.16,1.32l-3.68,2.13a2.6,2.6,0,0,1-2.3.1l-4.05-2.35c-.59-.34-.52-.93.16-1.32l3.68-2.13A2.57,2.57,0,0,1,494.48,211.55Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.2,206.19l4.06,2.34c.58.34.51.94-.17,1.33L485.41,212a2.52,2.52,0,0,1-2.29.1l-4.06-2.34c-.59-.34-.52-.94.16-1.33l3.69-2.12A2.52,2.52,0,0,1,485.2,206.19Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.92,200.83l4.06,2.35c.59.34.51.93-.17,1.32l-3.68,2.13a2.55,2.55,0,0,1-2.29.09l-4.06-2.34c-.59-.34-.51-.93.16-1.32l3.69-2.13A2.55,2.55,0,0,1,475.92,200.83Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.64,195.48l4.06,2.34c.59.34.51.93-.17,1.32l-3.68,2.13a2.54,2.54,0,0,1-2.29.09L460.5,199c-.59-.34-.51-.93.17-1.32l3.68-2.13A2.54,2.54,0,0,1,466.64,195.48Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.36,190.12l4.06,2.34c.59.34.51.93-.16,1.33l-3.69,2.12a2.55,2.55,0,0,1-2.29.1l-4.06-2.34c-.59-.34-.51-.94.17-1.33l3.68-2.13A2.55,2.55,0,0,1,457.36,190.12Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.08,184.76l4.06,2.35c.59.34.52.93-.16,1.32l-3.69,2.13a2.54,2.54,0,0,1-2.29.09l-4.06-2.34c-.58-.34-.51-.93.17-1.33l3.68-2.12A2.55,2.55,0,0,1,448.08,184.76Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.21,243.72l7,4.06c.62.36.54,1-.18,1.4l-3.54,2a2.7,2.7,0,0,1-2.42.1l-7-4.06c-.62-.36-.55-1,.17-1.4l3.54-2.05A2.75,2.75,0,0,1,550.21,243.72Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.78,181.12l1.21.7c.52.3.45.82-.15,1.17l-4,2.29a2.2,2.2,0,0,1-2,.08l-1.21-.69c-.52-.3-.46-.83.14-1.17l4-2.29A2.25,2.25,0,0,1,441.78,181.12Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.14,236.51l10.5,6.06c.51.3.45.82-.15,1.17l-4,2.29a2.21,2.21,0,0,1-2,.09L550,240.06c-.52-.3-.46-.82.14-1.17l4-2.3A2.26,2.26,0,0,1,556.14,236.51Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488,186.55l10.5,6.06c.51.3.45.82-.15,1.17l-4,2.3a2.24,2.24,0,0,1-2,.08l-10.5-6.06c-.52-.3-.45-.82.14-1.17l4-2.29A2.23,2.23,0,0,1,488,186.55Z",
    style: {
      fill: "#333"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M596.74,194.09c1.9,1.1,1.9,2.89,0,4l-36,20.78a7.69,7.69,0,0,1-6.9,0l-57.45-33.17c-1.89-1.09-1.89-2.89,0-4l36-20.79a7.69,7.69,0,0,1,6.9,0Z",
    style: {
      fill: "#b3b3b3"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "324.58 211.61 270.53 166.91 459.73 0 513.78 44.7 324.58 211.61",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.78 236.59 341.77 225.83 530.97 58.92 543.98 69.68 354.78 236.59",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "429.25 298.18 381.12 258.37 570.32 91.46 618.46 131.27 429.25 298.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "472.51 333.96 450.97 316.15 640.18 149.24 661.72 167.05 472.51 333.96",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.92
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.05,53.76,532.53,136.6V273.36L389.05,190.53V53.76m-3.36-5.82V192.47l150.2,86.72V134.66L385.69,47.94Z",
    style: {
      fill: "#333"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.92
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "386.87 191.79 386.87 49.97 534.72 135.33 534.72 277.16 386.87 191.79",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388,52l145.51,84V275.13L388,191.12V52m-2.35-4.06V192.47l150.2,86.72V134.66L385.69,47.94Z",
    style: {
      fill: "#333"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M386.71,47.44l-1,.5,150.2,86.72,2.1-1L389.49,47.52A2.92,2.92,0,0,0,386.71,47.44Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538,277V133.64l-2.1,1V279.19l1.44-1A1.48,1.48,0,0,0,538,277Z",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "person",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427.44,207.23c-.23-1.16-.55-2.34-.83-3.49s-.68-2.32-1.07-3.43-.79-2.19-1.22-3.21-.88-2-1.28-2.83a43.3,43.3,0,0,0-2.31-4.09c-.63-.94-1-1.43-1-1.43s.27.58.69,1.58c.2.5.44,1.11.7,1.8s.53,1.48.85,2.32.59,1.75.88,2.71.57,2,.88,3,.52,2.11.82,3.2.5,2.18.71,3.26.43,2.11.59,3.14l2.25,1.3-.06-.42C427.9,209.55,427.63,208.38,427.44,207.23Z",
    style: {
      fill: "#991f1f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.06,238.36c.3-.74.51-1.56.83-2.24s.56-1.4.87-2,.62-1.17.89-1.7.57-1,.84-1.35.5-.71.71-1c.41-.52.68-.8.68-.8a4.83,4.83,0,0,0-1,.26,8.18,8.18,0,0,0-2.32,1.41,10.6,10.6,0,0,0-1.28,1.36,12,12,0,0,0-1.22,1.8,23.51,23.51,0,0,0-1.07,2.19c-.28.82-.6,1.64-.83,2.54-.14.69-.33,1.35-.46,2l2.31,1.33c.13-.47.25-.94.36-1.43C482.56,240,482.85,239.19,483.06,238.36Z",
    style: {
      fill: "#991f1f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.41,124.55s-1,25.23-6.45,31.29c0,0,30,38.52,71,40.37,0,0-7.69-18.08-5.31-34.74Z",
    style: {
      fill: "#703d18"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "464.58 207.52 443.1 195.11 443.1 165.98 464.58 178.38 464.58 207.52",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "443.06 181.27 465.21 179.84 443.06 161.22 443.06 181.27",
    style: {
      fill: "#aeaeaf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.59,120.66c0,21.89,11.93,46.56,26.77,55.62V103.85C438.78,96,426.59,99.08,426.59,120.66Z",
    style: {
      fill: "#dfe5e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.6,104.54c-.41-.24-.83-.46-1.24-.69v72.43l.62.38c15.13,8.73,27.39-2.18,27.39-24.37S469.73,113.28,454.6,104.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.2,123.06a51.26,51.26,0,0,0,17.68,28.84s6.36-37.65-26.16-56.43-33.93,4.72-33.93,21.74C422.79,117.21,446.82,133.52,465.2,123.06Z",
    style: {
      fill: "#703d18"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.61,153.22c-.59,4.29.54,9,2.53,10.45s4.07-.8,4.65-5.09-.54-9-2.52-10.45S479.2,148.92,478.61,153.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.45,123.88c.38,4.79-.78,8-2.6,7.14s-3.61-5.42-4-10.21.78-8,2.6-7.15S428.06,119.08,428.45,123.88Z",
    style: {
      fill: "#dfe5e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.81,218.2l-4.9-2.43,3.85,5.84-6,11.19,14,8.06c.13-.69.32-1.35.46-2.05.23-.89.55-1.71.83-2.53a23.51,23.51,0,0,1,1.07-2.19,12,12,0,0,1,1.22-1.8,10.6,10.6,0,0,1,1.28-1.36,7.73,7.73,0,0,1,2.32-1.41,4.15,4.15,0,0,1,1-.26,9.19,9.19,0,0,0-.68.8c-.21.27-.45.59-.71,1s-.53.87-.84,1.34-.6,1.07-.89,1.7-.57,1.31-.87,2-.53,1.5-.83,2.24-.5,1.6-.71,2.45c-.11.49-.23,1-.36,1.43l14.91,8.61c-2.15-10.61-8.62-34.77-25.1-50.05l1.71,1.8Z",
    style: {
      fill: "#cc2929"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.23,206.63c-.21-1.08-.5-2.19-.71-3.26s-.51-2.16-.82-3.2-.57-2-.88-3-.61-1.86-.88-2.71-.57-1.63-.85-2.32-.5-1.3-.7-1.8c-.42-1-.69-1.58-.69-1.58s.4.49,1,1.43a43.3,43.3,0,0,1,2.31,4.09c.4.87.88,1.82,1.28,2.83s.84,2.1,1.22,3.21.72,2.26,1.07,3.43.6,2.33.83,3.49.46,2.32.57,3.42l.06.42,14.08,8.13-7.49-19,4.2-1.59-5.6-3.63.7-13.64,3.53-.12c-6.3-1.68-22.9-3.7-26.8,19.82l15.13,8.74C425.66,208.74,425.41,207.68,425.23,206.63Z",
    style: {
      fill: "#cc2929"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "449.77 189.38 440.36 182.32 440.22 182.39 439.62 182.72 448.43 217.5 450 223.73 453.84 225.95 453.84 192.57 449.77 189.38",
    style: {
      fill: "#eba9a9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "467.17 196.26 458.38 196.13 453.84 192.57 453.84 225.95 458.82 228.82 460.05 224.21 466.74 199.12 467.41 196.82 467.17 196.26",
    style: {
      fill: "#eba9a9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "473.51 202.56 471.8 200.76 467.56 196.32 467.41 196.82 466.74 199.12 460.04 221.91 458.13 228.42 460.34 229.7 465.72 232.8 471.76 221.61 467.91 215.77 472.81 218.2 473.51 202.56",
    style: {
      fill: "#1a1a1a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "448.42 216.65 439.62 182.72 439.38 181.79 439.21 181.15 437.49 181.21 433.96 181.33 433.26 194.97 438.86 198.6 434.66 200.19 442.15 219.2 448.13 222.65 450.3 223.9 448.42 216.65",
    style: {
      fill: "#1a1a1a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "443.06 179.76 453.91 192.85 444.53 201.72 439.21 181.15 443.06 179.76",
    style: {
      fill: "#e07e7e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "464.76 191.89 467.56 196.32 463.28 210.93 453.91 192.85 464.76 191.89",
    style: {
      fill: "#e07e7e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.18,112.79s4.72-24.52,27.4-11.43,28.67,40.26,28.67,40.26l-3.45-1.57s-5.62-21.14-24.58-32.08-25.68,6.18-25.68,6.18Z",
    style: {
      fill: "#cc2929"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.71,142.23s2.17,22.47,1.63,23.62c0,0,7.26,5.43,7.44-1.12V153.29s-.29-4.18-4.54-8.44l-3.81-2.2",
    style: {
      fill: "#801336"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.67,165.49s16.05,7.83,22.58,2.83c0,0,1.62-.38,2.78,2.92s-16,2.28-25.36-2.62c0,0-.42,1.68-5-.87s-5.66-4.94-5.66-4.94-2.2-4.16.42-4.69a6.08,6.08,0,0,1,4.82,1.54S456.73,162.55,457.67,165.49Z",
    style: {
      fill: "#cc2929"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "260.53 264.73 385.69 192.47 535.89 279.19 410.73 351.45 260.53 264.73",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276,266.61a1.23,1.23,0,0,1,0-2.34l108.92-62.89a4.47,4.47,0,0,1,4.06,0l131.52,75.93a1.23,1.23,0,0,1,0,2.34L411.54,342.54a4.47,4.47,0,0,1-4.06,0Z",
    style: {
      fill: "none",
      stroke: "#999",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.342582868768929px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.53,268v-3.22l150.2,86.72v5.89L262.85,272A4.63,4.63,0,0,1,260.53,268Z",
    style: {
      fill: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.89,283.47v-4.28L410.73,351.45v5.89L534.5,285.88A2.79,2.79,0,0,0,535.89,283.47Z",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Kaps-2",
    "data-name": "Kaps"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386.35,215.55l-4.66-2.69c-.42-.24-.37-.67.12-1l1.3-.75a1.82,1.82,0,0,1,1.65-.07l4.66,2.69c.42.24.37.67-.12.95l-1.3.75A1.85,1.85,0,0,1,386.35,215.55Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.81,224.48l-4.65-2.69c-.43-.24-.37-.67.12-.95l1.3-.75a1.79,1.79,0,0,1,1.65-.07l4.65,2.68c.43.25.37.67-.12,1l-1.3.75A1.85,1.85,0,0,1,401.81,224.48Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.09,229.83l-4.65-2.68c-.43-.25-.37-.67.11-1l1.31-.75a1.85,1.85,0,0,1,1.65-.07l4.65,2.69c.42.25.37.67-.12.95l-1.3.76A1.82,1.82,0,0,1,411.09,229.83Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.37,235.19l-4.66-2.69c-.42-.24-.37-.67.12-.95l1.31-.75a1.83,1.83,0,0,1,1.64-.07l4.66,2.69c.42.24.37.67-.12,1l-1.3.75A1.85,1.85,0,0,1,420.37,235.19Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.65,240.55,425,237.86c-.42-.24-.37-.67.12-1l1.3-.75a1.79,1.79,0,0,1,1.65-.07l4.66,2.68c.42.25.37.68-.12,1l-1.3.75A1.85,1.85,0,0,1,429.65,240.55Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.13,269.12l-4.65-2.69c-.43-.24-.37-.67.12-.95l1.3-.75a1.79,1.79,0,0,1,1.65-.07l4.65,2.68c.43.25.37.68-.12,1l-1.3.75A1.85,1.85,0,0,1,479.13,269.12Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.41,274.47l-4.65-2.68c-.43-.25-.37-.67.11-1l1.31-.75a1.85,1.85,0,0,1,1.65-.07l4.65,2.69c.42.25.37.67-.12.95l-1.3.76A1.82,1.82,0,0,1,488.41,274.47Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.69,279.83,493,277.14c-.42-.24-.37-.67.12-.95l1.31-.75a1.83,1.83,0,0,1,1.64-.07l4.66,2.69c.42.24.37.67-.12.95l-1.3.75A1.82,1.82,0,0,1,497.69,279.83Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.84,220.69l-4.06-2.34c-.59-.34-.51-.93.17-1.32l3.68-2.13a2.54,2.54,0,0,1,2.29-.09l4.06,2.34c.59.34.51.93-.17,1.32l-3.68,2.13A2.54,2.54,0,0,1,376.84,220.69Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.12,226.05l-4.06-2.34c-.59-.34-.51-.93.16-1.32l3.69-2.13a2.55,2.55,0,0,1,2.29-.1l4.06,2.35c.59.34.51.93-.17,1.32L388.41,226A2.55,2.55,0,0,1,386.12,226.05Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380,233.16l-4.06-2.35c-.59-.34-.51-.93.17-1.32l3.68-2.13a2.54,2.54,0,0,1,2.29-.09l4.06,2.34c.59.34.51.93-.17,1.32l-3.68,2.13A2.58,2.58,0,0,1,380,233.16Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.28,238.51l-4.06-2.34c-.59-.34-.51-.93.16-1.32l3.69-2.13a2.55,2.55,0,0,1,2.29-.1l4.06,2.35c.59.34.51.93-.17,1.32l-3.68,2.13A2.55,2.55,0,0,1,389.28,238.51Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.56,243.87l-4.06-2.34c-.59-.34-.52-.94.16-1.33l3.69-2.12a2.52,2.52,0,0,1,2.29-.1l4.06,2.34c.58.34.51.94-.17,1.33l-3.68,2.12A2.52,2.52,0,0,1,398.56,243.87Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.83,249.23l-4.05-2.35c-.59-.34-.52-.93.16-1.32l3.68-2.13a2.57,2.57,0,0,1,2.3-.09l4.05,2.34c.59.34.52.93-.16,1.32l-3.68,2.13A2.57,2.57,0,0,1,407.83,249.23Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.11,254.58l-4.06-2.34c-.58-.34-.51-.93.17-1.32l3.68-2.13a2.58,2.58,0,0,1,2.29-.1l4.06,2.35c.59.34.52.93-.16,1.32l-3.69,2.13A2.54,2.54,0,0,1,417.11,254.58Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.39,259.94l-4.06-2.34c-.59-.34-.51-.93.17-1.33l3.68-2.12a2.52,2.52,0,0,1,2.29-.1l4.06,2.34c.59.34.52.94-.16,1.33l-3.69,2.12A2.52,2.52,0,0,1,426.39,259.94Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.67,265.3,431.61,263c-.59-.34-.51-.93.17-1.32l3.68-2.13a2.54,2.54,0,0,1,2.29-.09l4.06,2.34c.59.34.51.93-.16,1.32L438,265.2A2.55,2.55,0,0,1,435.67,265.3Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445,270.65l-4.06-2.34c-.59-.34-.51-.93.16-1.32l3.69-2.13a2.54,2.54,0,0,1,2.29-.09l4.06,2.34c.59.34.51.93-.17,1.32l-3.68,2.13A2.55,2.55,0,0,1,445,270.65Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.23,276l-4.06-2.34c-.59-.34-.52-.93.16-1.33l3.69-2.12a2.55,2.55,0,0,1,2.29-.1l4.06,2.34c.58.34.51.94-.17,1.33l-3.68,2.13A2.55,2.55,0,0,1,454.23,276Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.5,281.37,459.45,279c-.59-.33-.52-.93.16-1.32l3.68-2.13a2.57,2.57,0,0,1,2.3-.09l4.05,2.34c.59.34.52.93-.16,1.33l-3.68,2.12A2.57,2.57,0,0,1,463.5,281.37Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.78,286.72l-4.06-2.34c-.58-.34-.51-.93.17-1.32l3.68-2.13a2.57,2.57,0,0,1,2.3-.09l4.05,2.34c.59.34.52.93-.16,1.32l-3.69,2.13A2.54,2.54,0,0,1,472.78,286.72Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.4,231.41l-4.06-2.34c-.59-.34-.52-.94.16-1.33l3.69-2.12a2.52,2.52,0,0,1,2.29-.1l4.06,2.34c.58.34.51.93-.17,1.33l-3.68,2.12A2.52,2.52,0,0,1,395.4,231.41Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.67,236.77l-4.05-2.35c-.59-.34-.52-.93.16-1.32l3.68-2.13a2.57,2.57,0,0,1,2.3-.09l4.05,2.34c.59.34.52.93-.16,1.32L407,236.67A2.6,2.6,0,0,1,404.67,236.77Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414,242.12l-4.06-2.34c-.58-.34-.51-.93.17-1.32l3.68-2.13a2.55,2.55,0,0,1,2.29-.1l4.06,2.35c.59.34.52.93-.16,1.32L416.24,242A2.54,2.54,0,0,1,414,242.12Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.23,247.48l-4.06-2.34c-.58-.34-.51-.94.17-1.33l3.68-2.12a2.52,2.52,0,0,1,2.29-.1l4.06,2.34c.59.34.52.94-.16,1.33l-3.69,2.12A2.52,2.52,0,0,1,423.23,247.48Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.51,252.84l-4.06-2.35c-.59-.34-.51-.93.17-1.32L432.3,247a2.54,2.54,0,0,1,2.29-.09l4.06,2.34c.59.34.51.93-.16,1.32l-3.69,2.13A2.55,2.55,0,0,1,432.51,252.84Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.79,258.19l-4.06-2.34c-.59-.34-.51-.93.16-1.32l3.69-2.13a2.58,2.58,0,0,1,2.29-.1l4.06,2.35c.59.34.51.93-.17,1.32l-3.68,2.13A2.55,2.55,0,0,1,441.79,258.19Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.07,263.55,447,261.21c-.59-.34-.52-.93.16-1.33l3.69-2.12a2.52,2.52,0,0,1,2.29-.1l4.06,2.34c.58.34.51.94-.17,1.33l-3.68,2.12A2.52,2.52,0,0,1,451.07,263.55Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.34,268.91l-4-2.35c-.59-.34-.52-.93.16-1.32l3.68-2.13a2.57,2.57,0,0,1,2.3-.09l4.05,2.34c.59.34.52.93-.16,1.32l-3.68,2.13A2.57,2.57,0,0,1,460.34,268.91Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.62,274.26l-4.06-2.34c-.58-.34-.51-.93.17-1.32l3.68-2.13a2.57,2.57,0,0,1,2.3-.09l4.05,2.34c.59.34.52.93-.16,1.32l-3.69,2.13A2.54,2.54,0,0,1,469.62,274.26Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.9,279.62l-4.06-2.34c-.58-.34-.51-.93.17-1.33l3.68-2.12a2.55,2.55,0,0,1,2.29-.1l4.06,2.34c.59.34.52.94-.16,1.33l-3.69,2.13A2.54,2.54,0,0,1,478.9,279.62Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.18,285l-4.06-2.35c-.59-.33-.51-.93.17-1.32l3.68-2.13a2.54,2.54,0,0,1,2.29-.09l4.06,2.34c.59.34.51.93-.16,1.33l-3.69,2.12A2.55,2.55,0,0,1,488.18,285Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.66,227.76l-7-4c-.62-.36-.54-1,.17-1.4l3.55-2.05a2.69,2.69,0,0,1,2.42-.1l7,4.06c.62.36.54,1-.17,1.4l-3.55,2A2.66,2.66,0,0,1,370.66,227.76Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.09,290.37l-1.21-.7c-.52-.3-.45-.83.15-1.17l4-2.29a2.25,2.25,0,0,1,2-.09l1.21.7c.52.3.46.83-.14,1.17l-4,2.29A2.25,2.25,0,0,1,479.09,290.37Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.79,238.47l-4.06-2.34c-.59-.34-.51-.93.16-1.32l3.69-2.13a2.54,2.54,0,0,1,2.29-.09l4.06,2.34c.59.34.51.93-.17,1.32l-3.68,2.13A2.55,2.55,0,0,1,370.79,238.47Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.67,245.58l-4.06-2.35c-.59-.33-.51-.93.17-1.32l3.68-2.13a2.54,2.54,0,0,1,2.29-.09l4.06,2.34c.59.34.51.93-.16,1.33L367,245.48A2.55,2.55,0,0,1,364.67,245.58Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.27,247.32,345.21,245c-.58-.34-.51-.93.17-1.32l3.68-2.13a2.55,2.55,0,0,1,2.29-.09l4.06,2.34c.59.34.52.93-.16,1.32l-3.69,2.13A2.54,2.54,0,0,1,349.27,247.32Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.55,252.68l-4.06-2.34c-.59-.34-.51-.93.17-1.33l3.68-2.12a2.55,2.55,0,0,1,2.29-.1l4.06,2.35c.59.33.52.93-.16,1.32l-3.69,2.13A2.54,2.54,0,0,1,358.55,252.68Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.59,281l-43.37-25c-.84-.48-.73-1.32.23-1.88l2.65-1.53a3.65,3.65,0,0,1,3.26-.13l43.37,25c.83.48.73,1.32-.24,1.88l-2.64,1.53A3.65,3.65,0,0,1,407.59,281Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,242l-4.05-2.35c-.59-.33-.52-.93.16-1.32l3.68-2.13a2.57,2.57,0,0,1,2.3-.09l4.05,2.34c.59.34.52.93-.16,1.33l-3.68,2.12A2.57,2.57,0,0,1,340,242Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374,250.93l-4.06-2.34c-.59-.34-.51-.93.16-1.32l3.69-2.13a2.54,2.54,0,0,1,2.29-.09l4.06,2.34c.59.34.51.93-.17,1.32l-3.68,2.13A2.55,2.55,0,0,1,374,250.93Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.23,256.29,379.17,254c-.59-.34-.52-.93.16-1.33L383,250.5a2.55,2.55,0,0,1,2.29-.1l4.06,2.35c.58.33.51.93-.17,1.32l-3.68,2.13A2.55,2.55,0,0,1,383.23,256.29Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.5,261.65l-4.05-2.35c-.59-.33-.52-.93.16-1.32l3.68-2.13a2.57,2.57,0,0,1,2.3-.09l4.05,2.34c.59.34.52.93-.16,1.33l-3.68,2.12A2.57,2.57,0,0,1,392.5,261.65Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.78,267l-4.06-2.34c-.58-.34-.51-.93.17-1.32l3.68-2.13a2.57,2.57,0,0,1,2.3-.09l4.05,2.34c.59.34.52.93-.16,1.32l-3.69,2.13A2.54,2.54,0,0,1,401.78,267Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.06,272.36,407,270c-.58-.34-.51-.93.17-1.32l3.68-2.13a2.55,2.55,0,0,1,2.29-.1l4.06,2.35c.59.34.52.93-.16,1.32l-3.69,2.13A2.54,2.54,0,0,1,411.06,272.36Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.34,277.72l-4.06-2.34c-.59-.34-.51-.94.17-1.33l3.68-2.12a2.52,2.52,0,0,1,2.29-.1l4.06,2.34c.59.34.51.93-.16,1.33l-3.69,2.12A2.52,2.52,0,0,1,420.34,277.72Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.62,283.08l-4.06-2.35c-.59-.34-.51-.93.16-1.32l3.69-2.13a2.54,2.54,0,0,1,2.29-.09l4.06,2.34c.59.34.51.93-.17,1.32L431.91,283A2.58,2.58,0,0,1,429.62,283.08Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.27,295.57l-4.06-2.34c-.59-.34-.51-.93.16-1.32l3.69-2.13a2.54,2.54,0,0,1,2.29-.09l4.06,2.34c.59.34.51.93-.17,1.32l-3.68,2.13A2.55,2.55,0,0,1,451.27,295.57Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.33,306.25l-4.05-2.34c-.59-.34-.52-.93.16-1.33l3.69-2.12a2.52,2.52,0,0,1,2.29-.1l4.06,2.34c.58.34.51.94-.17,1.33l-3.68,2.12A2.54,2.54,0,0,1,451.33,306.25Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.06,300.89,438,298.55c-.59-.34-.52-.93.16-1.32l3.69-2.13a2.58,2.58,0,0,1,2.29-.1l4.06,2.35c.58.34.51.93-.17,1.32l-3.68,2.13A2.55,2.55,0,0,1,442.06,300.89Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.78,295.54l-4.06-2.35c-.59-.34-.51-.93.16-1.32l3.69-2.13a2.54,2.54,0,0,1,2.29-.09l4.06,2.34c.59.34.51.93-.17,1.32l-3.68,2.13A2.55,2.55,0,0,1,432.78,295.54Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.07,243.83,376,241.49c-.59-.34-.52-.93.16-1.33l3.69-2.12a2.55,2.55,0,0,1,2.29-.1l4.06,2.34c.58.34.51.94-.17,1.33l-3.68,2.13A2.55,2.55,0,0,1,380.07,243.83Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.34,249.19l-4-2.35c-.59-.33-.52-.93.16-1.32l3.68-2.13a2.57,2.57,0,0,1,2.3-.09l4.05,2.34c.59.34.52.93-.16,1.33l-3.68,2.12A2.57,2.57,0,0,1,389.34,249.19Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.62,254.54l-4.06-2.34c-.58-.34-.51-.93.17-1.32l3.68-2.13a2.57,2.57,0,0,1,2.3-.09l4.05,2.34c.59.34.52.93-.16,1.32l-3.69,2.13A2.54,2.54,0,0,1,398.62,254.54Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.9,259.9l-4.06-2.34c-.58-.34-.51-.93.17-1.33l3.68-2.12A2.55,2.55,0,0,1,410,254l4.06,2.35c.59.33.52.93-.16,1.32l-3.69,2.13A2.54,2.54,0,0,1,407.9,259.9Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.18,265.26l-4.06-2.35c-.59-.33-.51-.93.17-1.32l3.68-2.13a2.54,2.54,0,0,1,2.29-.09l4.06,2.34c.59.34.51.93-.16,1.33l-3.69,2.12A2.55,2.55,0,0,1,417.18,265.26Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.46,270.61l-4.06-2.34c-.59-.34-.51-.93.16-1.32l3.69-2.13a2.54,2.54,0,0,1,2.29-.09l4.06,2.34c.59.34.51.93-.17,1.32l-3.68,2.13A2.54,2.54,0,0,1,426.46,270.61Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.74,276l-4.06-2.34c-.59-.34-.52-.93.16-1.32l3.69-2.13a2.55,2.55,0,0,1,2.29-.1l4.06,2.35c.58.34.51.93-.17,1.32L438,275.88A2.55,2.55,0,0,1,435.74,276Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445,281.33,441,279c-.59-.34-.52-.94.16-1.33l3.69-2.12a2.52,2.52,0,0,1,2.29-.1l4.06,2.34c.58.34.51.93-.17,1.33l-3.68,2.12A2.54,2.54,0,0,1,445,281.33Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.29,286.69l-4.06-2.35c-.58-.34-.51-.93.17-1.32l3.68-2.13a2.57,2.57,0,0,1,2.3-.09l4.05,2.34c.59.34.52.93-.16,1.32l-3.68,2.13A2.6,2.6,0,0,1,454.29,286.69Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.57,292l-4.06-2.34c-.58-.34-.51-.93.17-1.32l3.68-2.13a2.55,2.55,0,0,1,2.29-.1l4.06,2.35c.59.34.52.93-.16,1.32L465.86,292A2.54,2.54,0,0,1,463.57,292Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.45,233.08l-7-4.06c-.62-.36-.54-1,.17-1.4l3.55-2a2.66,2.66,0,0,1,2.42-.1l7,4.06c.62.35.54,1-.18,1.4l-3.54,2A2.66,2.66,0,0,1,361.45,233.08Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.88,295.68l-1.21-.69c-.52-.3-.46-.83.15-1.18l4-2.29a2.28,2.28,0,0,1,2-.08l1.21.7c.52.3.45.82-.15,1.17l-4,2.29A2.25,2.25,0,0,1,469.88,295.68Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.52,240.29,345,234.23c-.52-.3-.45-.82.14-1.16l4-2.3a2.26,2.26,0,0,1,2-.08l10.5,6.06c.52.3.45.82-.15,1.16l-4,2.3A2.23,2.23,0,0,1,355.52,240.29Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.63,290.25l-10.5-6.06c-.52-.3-.45-.82.14-1.16l4-2.3a2.23,2.23,0,0,1,2-.08l10.5,6.06c.51.3.45.82-.15,1.16l-4,2.3A2.24,2.24,0,0,1,423.63,290.25Z",
    style: {
      fill: "#333"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M314.91,282.71c-1.89-1.09-1.89-2.88,0-4l36-20.78a7.63,7.63,0,0,1,6.9,0l57.45,33.16c1.9,1.1,1.9,2.89,0,4l-36,20.78a7.63,7.63,0,0,1-6.9,0Z",
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("image", {
    width: 157,
    height: 220,
    transform: "translate(396.99 45.67)",
    xlinkHref: "data:image/png;base64,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",
    style: {
      opacity: 0.27,
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.45,60.26,443.1,78.4l31.59,18.25,63,36.74.28.16v.32c0,19.42.16,38.83.13,58.25l0,29.12L538,250.36l-.4-29.12-.29-29.12c-.22-19.41-.29-38.83-.43-58.24l.28.48L474.2,97.48,442.79,78.93Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "block",
    id: "side-block-2",
    "data-name": "side-block"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bolck-9",
    "data-name": "bolck"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "560.89 686.38 626.13 648.72 626.13 652.76 560.89 690.43 560.89 686.38",
    style: {
      fill: "#0f1145"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "691.37 690.43 691.37 686.38 626.13 648.72 626.13 652.76 691.37 690.43",
    style: {
      fill: "#2e3192"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "626.13 652.76 691.37 690.43 626.33 729.03 560.89 690.43 626.13 652.76",
    style: {
      fill: "url(#linear-gradient-49)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "626.13 623.61 517.4 686.38 539.15 698.94 626.13 648.72 713.12 698.94 734.87 686.38 626.13 623.61",
    style: {
      fill: "url(#linear-gradient-50)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "626.13 749.16 539.15 698.94 560.89 686.38 626.13 724.05 691.37 686.38 713.12 698.94 626.13 749.16",
    style: {
      fill: "url(#linear-gradient-51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "517.4 711.5 517.4 686.38 626.13 749.16 626.13 774.27 517.4 711.5",
    style: {
      fill: "#20142c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "734.87 686.38 734.87 711.5 626.13 774.27 626.13 749.16 734.87 686.38",
    style: {
      fill: "url(#linear-gradient-52)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "bolck-10",
    "data-name": "bolck"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "560.89 655.47 626.13 617.81 626.13 621.85 560.89 659.52 560.89 655.47",
    style: {
      fill: "#0f1145"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "691.37 659.52 691.37 655.47 626.13 617.81 626.13 621.85 691.37 659.52",
    style: {
      fill: "#2e3192"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "626.13 621.85 691.37 659.52 626.33 698.12 560.89 659.52 626.13 621.85",
    style: {
      fill: "url(#linear-gradient-53)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "626.13 592.7 517.4 655.47 539.15 668.03 626.13 617.81 713.12 668.03 734.87 655.47 626.13 592.7",
    style: {
      fill: "url(#linear-gradient-54)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "626.13 718.25 539.15 668.03 560.89 655.47 626.13 693.14 691.37 655.47 713.12 668.03 626.13 718.25",
    style: {
      fill: "url(#linear-gradient-55)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "517.4 680.59 517.4 655.47 626.13 718.25 626.13 743.36 517.4 680.59",
    style: {
      fill: "#20142c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "734.87 655.47 734.87 680.59 626.13 743.36 626.13 718.25 734.87 655.47",
    style: {
      fill: "url(#linear-gradient-56)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "light",
    id: "light-9",
    "data-name": "light"
  }, /*#__PURE__*/React.createElement("image", {
    width: 227,
    height: 79,
    transform: "translate(513 675.67)",
    xlinkHref: "data:image/png;base64,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",
    style: {
      opacity: 0.75,
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "519.48 686.02 519.48 681.78 626.13 743.36 626.13 747.59 519.48 686.02",
    style: {
      fill: "url(#linear-gradient-57)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "732.5 681.95 732.5 686.18 626.13 747.59 626.13 743.36 732.5 681.95",
    style: {
      fill: "url(#linear-gradient-58)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bolck-11",
    "data-name": "bolck"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "560.89 624.45 626.13 586.78 626.13 590.82 560.89 628.49 560.89 624.45",
    style: {
      fill: "#0f1145"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "691.37 628.49 691.37 624.45 626.13 586.78 626.13 590.82 691.37 628.49",
    style: {
      fill: "#2e3192"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "626.13 590.82 691.37 628.49 626.33 667.09 560.89 628.49 626.13 590.82",
    style: {
      fill: "url(#linear-gradient-59)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "626.13 561.67 517.4 624.45 539.15 637 626.13 586.78 713.12 637 734.87 624.45 626.13 561.67",
    style: {
      fill: "url(#linear-gradient-60)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "626.13 687.22 539.15 637 560.89 624.45 626.13 662.11 691.37 624.45 713.12 637 626.13 687.22",
    style: {
      fill: "url(#linear-gradient-61)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "517.4 649.56 517.4 624.45 626.13 687.22 626.13 712.33 517.4 649.56",
    style: {
      fill: "#20142c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "734.87 624.45 734.87 649.56 626.13 712.33 626.13 687.22 734.87 624.45",
    style: {
      fill: "url(#linear-gradient-62)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "light",
    id: "light-10",
    "data-name": "light"
  }, /*#__PURE__*/React.createElement("image", {
    width: 227,
    height: 79,
    transform: "translate(513 644.67)",
    xlinkHref: "data:image/png;base64,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",
    style: {
      opacity: 0.75,
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "519.48 654.99 519.48 650.75 626.13 712.33 626.13 716.57 519.48 654.99",
    style: {
      fill: "url(#linear-gradient-63)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "732.5 650.92 732.5 655.15 626.13 716.57 626.13 712.33 732.5 650.92",
    style: {
      fill: "url(#linear-gradient-64)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bolck-12",
    "data-name": "bolck"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "560.89 593.48 626.13 555.81 626.13 559.86 560.89 597.52 560.89 593.48",
    style: {
      fill: "#0f1145"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "691.37 597.52 691.37 593.48 626.13 555.81 626.13 559.86 691.37 597.52",
    style: {
      fill: "#2e3192"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "626.13 559.86 691.37 597.52 626.33 636.13 560.89 597.52 626.13 559.86",
    style: {
      fill: "url(#linear-gradient-65)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "626.13 530.7 517.4 593.48 539.15 606.04 626.13 555.81 713.12 606.04 734.87 593.48 626.13 530.7",
    style: {
      fill: "url(#linear-gradient-66)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "626.13 656.26 539.15 606.04 560.89 593.48 626.13 631.15 691.37 593.48 713.12 606.04 626.13 656.26",
    style: {
      fill: "url(#linear-gradient-67)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "517.4 618.59 517.4 593.48 626.13 656.26 626.13 681.37 517.4 618.59",
    style: {
      fill: "#20142c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "734.87 593.48 734.87 618.59 626.13 681.37 626.13 656.26 734.87 593.48",
    style: {
      fill: "url(#linear-gradient-68)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "light",
    id: "light-11",
    "data-name": "light"
  }, /*#__PURE__*/React.createElement("image", {
    width: 227,
    height: 79,
    transform: "translate(513 613.67)",
    xlinkHref: "data:image/png;base64,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",
    style: {
      opacity: 0.75,
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "519.48 624.02 519.48 619.79 626.13 681.37 626.13 685.6 519.48 624.02",
    style: {
      fill: "url(#linear-gradient-69)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "732.5 619.95 732.5 624.19 626.13 685.6 626.13 681.37 732.5 619.95",
    style: {
      fill: "url(#linear-gradient-70)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "glow-2",
    "data-name": "glow"
  }, /*#__PURE__*/React.createElement("g", {
    className: "light",
    id: "light-12",
    "data-name": "light"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "560.89 593.48 560.89 468.01 626.13 430.35 626.13 555.81 560.89 593.48",
    style: {
      opacity: 0.4,
      fill: "url(#linear-gradient-71)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "691.37 593.48 691.37 468.01 626.13 430.35 626.13 555.81 691.37 593.48",
    style: {
      opacity: 0.4,
      fill: "url(#linear-gradient-72)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "float-up-higher",
    id: "floater-2",
    "data-name": "floater"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "584.91 495.15 591.46 491.35 607.04 500.35 600.5 504.15 584.91 495.15",
    style: {
      fill: "#ab2638"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-7)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M600.5,504.15l6.54-3.81a.76.76,0,0,1,0,.15l-6.55,3.8v-.14",
    style: {
      fill: "#952131"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.5,504.29l6.55-3.8c0,.13,0,.26.05.39l-6.55,3.81c0-.13,0-.27,0-.4",
    style: {
      fill: "#9f2334"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.55,504.69l6.55-3.81c0,.14,0,.28.08.42l-6.55,3.81c0-.14-.06-.28-.08-.42",
    style: {
      fill: "#a92537"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.63,505.11l6.55-3.81c0,.14.07.28.12.43l-6.55,3.8c0-.14-.08-.28-.12-.42",
    style: {
      fill: "#b3283b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.75,505.53l6.55-3.8c0,.13.09.27.14.41l-6.55,3.8c0-.13-.1-.27-.14-.41",
    style: {
      fill: "#bd2a3e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.89,505.94l6.55-3.8c0,.13.1.26.16.39l-6.55,3.8c-.06-.13-.11-.26-.16-.39",
    style: {
      fill: "#c72c41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.05,506.33l6.55-3.8c.06.14.13.28.2.41l-6.55,3.81c-.07-.14-.14-.28-.2-.42",
    style: {
      fill: "#d25465"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.25,506.75l6.55-3.81a6.75,6.75,0,0,0,.72,1.15L602,507.9a8.53,8.53,0,0,1-.72-1.15",
    style: {
      fill: "#d66574"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602,507.9l6.55-3.81c.11.14.21.27.32.39l-6.55,3.81-.32-.39",
    style: {
      fill: "#d25465"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.29,508.29l6.55-3.81c.1.12.21.24.32.35l-6.54,3.8c-.12-.11-.22-.22-.33-.34",
    style: {
      fill: "#c72c41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.62,508.63l6.54-3.8.36.32L603,509l-.35-.32",
    style: {
      fill: "#bd2a3e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603,509l6.55-3.8a3,3,0,0,0,.35.27l-6.55,3.81c-.12-.09-.24-.18-.35-.28",
    style: {
      fill: "#b3283b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.32,509.23l6.55-3.81.34.23-6.55,3.8-.34-.22",
    style: {
      fill: "#a92537"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.66,509.45l6.55-3.8h0l.3.16L604,509.63l-.29-.16,0,0",
    style: {
      fill: "#9f2334"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604,509.63l6.55-3.81a2.26,2.26,0,0,0,.33.13l-6.55,3.81-.33-.13",
    style: {
      fill: "#952131"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.32,509.76l6.55-3.81.32.1-6.55,3.8-.32-.09",
    style: {
      fill: "#8b1f2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.64,509.85l6.55-3.8.35.05L605,509.91l-.36-.06",
    style: {
      fill: "#811d2a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605,509.91l6.54-3.81a2.77,2.77,0,0,0,.41,0l-6.55,3.8a2.61,2.61,0,0,1-.4,0",
    style: {
      fill: "#771a27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.4,509.89l6.55-3.8a1.6,1.6,0,0,0,.58-.2l-6.55,3.8a1.6,1.6,0,0,1-.58.2",
    style: {
      fill: "#6d1824"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-8)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M601.42,501.84,608,498a1.79,1.79,0,0,0-.72.85l-6.54,3.81a1.71,1.71,0,0,1,.71-.86",
    style: {
      fill: "#832623"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.71,502.7l6.54-3.81a2.7,2.7,0,0,0-.13.43l-6.55,3.81a1.81,1.81,0,0,1,.14-.43",
    style: {
      fill: "#8f2926"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.57,503.13l6.55-3.81a3.91,3.91,0,0,0-.07.39l-6.54,3.8a2.32,2.32,0,0,1,.06-.38",
    style: {
      fill: "#9b2d2a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.51,503.51l6.54-3.8c0,.12,0,.25,0,.38l-6.54,3.81a2.55,2.55,0,0,1,0-.39",
    style: {
      fill: "#a7302d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.49,503.9l6.54-3.81h0c0,.08,0,.16,0,.24l-6.54,3.81a1.93,1.93,0,0,1,0-.24h0",
    style: {
      fill: "#b33430"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-9)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M625.77,539.63l6.55-3.81.06.28-6.55,3.81-.06-.28",
    style: {
      fill: "#a92537"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.83,539.91l6.55-3.81c.15.66.4,1.32.55,2l-6.55,3.81c-.15-.65-.4-1.32-.55-2",
    style: {
      fill: "#b3283b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.38,541.88l6.55-3.81c0,.14.06.27.08.41l-6.55,3.81c0-.14-.05-.28-.08-.41",
    style: {
      fill: "#a92537"
    }
  })))), /*#__PURE__*/React.createElement("polygon", {
    points: "606.92 507.86 613.47 504.05 616.93 506.05 610.38 509.86 606.92 507.86",
    style: {
      fill: "#ab2638"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-10)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M589.81,483.7l6.55-3.81A9.93,9.93,0,0,1,600,478.6l-6.54,3.8a10.11,10.11,0,0,0-3.68,1.3",
    style: {
      fill: "#832623"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.49,482.4l6.54-3.8a9.64,9.64,0,0,1,2-.07l-6.55,3.8a9.54,9.54,0,0,0-2,.07",
    style: {
      fill: "#8f2926"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.5,482.33l6.55-3.8a10.06,10.06,0,0,1,1.07.13l-6.55,3.81a10.12,10.12,0,0,0-1.07-.14",
    style: {
      fill: "#9b2d2a"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-11)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M610.38,509.86l6.55-3.81a.66.66,0,0,0,0,.14L610.39,510a.71.71,0,0,1,0-.14",
    style: {
      fill: "#952131"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.39,510l6.55-3.81c0,.13,0,.27,0,.4l-6.55,3.8c0-.13,0-.26,0-.39",
    style: {
      fill: "#9f2334"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.43,510.39l6.55-3.8c0,.14,0,.28.08.41l-6.54,3.81c0-.14-.06-.28-.09-.42",
    style: {
      fill: "#a92537"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.52,510.81l6.54-3.81.12.43-6.55,3.81c0-.15-.08-.29-.11-.43",
    style: {
      fill: "#b3283b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.63,511.24l6.55-3.81c0,.14.09.28.14.41l-6.55,3.81c0-.14-.1-.28-.14-.41",
    style: {
      fill: "#bd2a3e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.77,511.65l6.55-3.81c0,.13.1.26.16.39L610.93,512c-.06-.13-.11-.26-.16-.39",
    style: {
      fill: "#c72c41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.93,512l6.55-3.81c.06.14.13.28.2.42l-6.55,3.8c-.07-.13-.14-.27-.2-.41",
    style: {
      fill: "#d25465"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.13,512.45l6.55-3.8a7.69,7.69,0,0,0,.73,1.15l-6.55,3.81a7.31,7.31,0,0,1-.73-1.16",
    style: {
      fill: "#d66574"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.86,513.61l6.55-3.81.31.39-6.55,3.8c-.11-.12-.21-.25-.31-.38",
    style: {
      fill: "#d25465"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.17,514l6.55-3.8.33.34-6.55,3.81-.33-.35",
    style: {
      fill: "#c72c41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.5,514.34l6.55-3.81.35.32-6.55,3.81-.35-.32",
    style: {
      fill: "#bd2a3e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.85,514.66l6.55-3.81.35.28-6.55,3.8a4.11,4.11,0,0,1-.35-.27",
    style: {
      fill: "#b3283b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.2,514.93l6.55-3.8.35.22-6.55,3.81-.35-.23",
    style: {
      fill: "#a92537"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.55,515.16l6.55-3.81,0,0,.3.16-6.55,3.8-.3-.15,0,0",
    style: {
      fill: "#9f2334"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.88,515.33l6.55-3.8.32.13-6.55,3.81-.32-.14",
    style: {
      fill: "#952131"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.2,515.47l6.55-3.81.33.09-6.55,3.81-.33-.09",
    style: {
      fill: "#8b1f2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.53,515.56l6.55-3.81a2.14,2.14,0,0,0,.35.06l-6.55,3.8a2.11,2.11,0,0,1-.35-.05",
    style: {
      fill: "#811d2a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.88,515.61l6.55-3.8a2.61,2.61,0,0,0,.4,0l-6.55,3.81a1.77,1.77,0,0,1-.4,0",
    style: {
      fill: "#771a27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.28,515.6l6.55-3.81a1.43,1.43,0,0,0,.58-.2l-6.55,3.81a1.6,1.6,0,0,1-.58.2",
    style: {
      fill: "#6d1824"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-12)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M611.31,507.55l6.55-3.81a1.72,1.72,0,0,0-.72.86l-6.55,3.81a1.72,1.72,0,0,1,.72-.86",
    style: {
      fill: "#832623"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.59,508.41l6.55-3.81a2.41,2.41,0,0,0-.14.43l-6.55,3.8a2.59,2.59,0,0,1,.14-.42",
    style: {
      fill: "#8f2926"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.45,508.83,617,505a2.32,2.32,0,0,0-.06.38l-6.55,3.81a2.28,2.28,0,0,1,.06-.39",
    style: {
      fill: "#9b2d2a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.39,509.22l6.55-3.81a2.55,2.55,0,0,0,0,.39l-6.55,3.81c0-.14,0-.27,0-.39",
    style: {
      fill: "#a7302d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.37,509.61l6.55-3.81h0a1.93,1.93,0,0,0,0,.24l-6.55,3.81a2.09,2.09,0,0,1,0-.24h0",
    style: {
      fill: "#b33430"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-13)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M625.13,531l6.54-3.81c0,.74,0,1.48,0,2.23l-6.55,3.8c0-.75,0-1.49,0-2.22",
    style: {
      fill: "#8b1f2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.08,533.23l6.55-3.8c0,.88,0,1.78.08,2.7l-6.54,3.8c-.08-.92-.1-1.81-.09-2.7",
    style: {
      fill: "#952131"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.17,535.93l6.54-3.8c0,.57.12,1.16.21,1.76l-6.55,3.8c-.09-.59-.16-1.18-.2-1.76",
    style: {
      fill: "#9f2334"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.37,537.69l6.55-3.8c.08.48.17,1,.29,1.48l-6.55,3.8c-.12-.5-.21-1-.29-1.48",
    style: {
      fill: "#a92537"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.66,539.17l6.55-3.8c0,.15.07.3.11.45l-6.55,3.81c0-.15-.08-.31-.11-.46",
    style: {
      fill: "#b3283b"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-14)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M625.33,529.48l6.55-3.81a.19.19,0,0,1,0,.08l-6.55,3.81a.22.22,0,0,0,0-.08",
    style: {
      fill: "#8b1f2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.32,529.56l6.55-3.81a1.2,1.2,0,0,1,0,.2l-6.55,3.81a.69.69,0,0,0,0-.2",
    style: {
      fill: "#811d2a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.29,529.76l6.55-3.81c-.05.2-.12.38-.16.58l-6.55,3.81c0-.2.12-.38.16-.58",
    style: {
      fill: "#771a27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.13,530.34l6.55-3.81a1.29,1.29,0,0,0,0,.19l-6.55,3.81a1.06,1.06,0,0,1,0-.19",
    style: {
      fill: "#811d2a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.09,530.53l6.55-3.81a.66.66,0,0,1,0,.14l-6.54,3.81v-.14",
    style: {
      fill: "#8b1f2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.09,530.67l6.54-3.81s0,.08,0,.12l-6.55,3.8v-.11",
    style: {
      fill: "#952131"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.09,530.78l6.55-3.8s0,.07,0,.11l-6.55,3.81s0-.08,0-.12",
    style: {
      fill: "#9f2334"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.1,530.9l6.55-3.81a.43.43,0,0,1,0,.11L625.13,531l0-.11",
    style: {
      fill: "#a92537"
    }
  })))), /*#__PURE__*/React.createElement("polygon", {
    points: "616.8 513.56 623.35 509.76 626.81 511.76 620.26 515.56 616.8 513.56",
    style: {
      fill: "#ab2638"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-15)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M596.57,482.47l6.55-3.81a9.19,9.19,0,0,1,1.13.19l-6.55,3.8a9.14,9.14,0,0,0-1.13-.18",
    style: {
      fill: "#9b2d2a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.7,482.65l6.55-3.8a11.23,11.23,0,0,1,1.61.47l-6.54,3.8a15.39,15.39,0,0,0-1.62-.47",
    style: {
      fill: "#a7302d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.32,483.12l6.54-3.8a22,22,0,0,1,2.28.95l-6.54,3.8c-.77-.36-1.53-.68-2.28-.95",
    style: {
      fill: "#b33430"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.6,484.07l6.54-3.8.69.33-6.55,3.8-.68-.33",
    style: {
      fill: "#be3733"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-16)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M652.91,570.22l6.55-3.8v0l-6.55,3.81v0",
    style: {
      fill: "#00344f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.92,570.26l6.55-3.81c0,.06,0,.12,0,.18l-6.55,3.8a1.11,1.11,0,0,0,0-.17",
    style: {
      fill: "#00314a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.94,570.43l6.55-3.8a.86.86,0,0,1,0,.16L653,570.6c0-.06,0-.11,0-.17",
    style: {
      fill: "#002e46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653,570.6l6.54-3.81V567l-6.55,3.8s0-.1,0-.15",
    style: {
      fill: "#002b41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.94,570.75l6.55-3.8,0,.16-6.55,3.81,0-.17",
    style: {
      fill: "#00283c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.91,570.92l6.55-3.81a.55.55,0,0,1-.06.18l-6.55,3.81a.64.64,0,0,0,.06-.18",
    style: {
      fill: "#002538"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.85,571.1l6.55-3.81a.79.79,0,0,1-.34.4l-6.55,3.81a.79.79,0,0,0,.34-.4",
    style: {
      fill: "#023"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-17)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M620.26,515.56l6.55-3.8a.71.71,0,0,0,0,.14l-6.55,3.8s0-.09,0-.14",
    style: {
      fill: "#952131"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.27,515.7l6.55-3.8a2.6,2.6,0,0,0,0,.39l-6.55,3.81c0-.13,0-.27-.05-.4",
    style: {
      fill: "#9f2334"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.32,516.1l6.55-3.81a3.1,3.1,0,0,0,.08.42l-6.55,3.81c0-.14-.06-.28-.08-.42",
    style: {
      fill: "#a92537"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.4,516.52l6.55-3.81c0,.14.07.28.11.43l-6.55,3.8c0-.14-.08-.28-.11-.42",
    style: {
      fill: "#b3283b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.51,516.94l6.55-3.8c0,.13.09.27.14.41l-6.55,3.8c0-.13-.09-.27-.14-.41",
    style: {
      fill: "#bd2a3e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.65,517.35l6.55-3.8c0,.13.1.26.16.39l-6.55,3.8-.16-.39",
    style: {
      fill: "#c72c41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.81,517.74l6.55-3.8c.06.14.13.28.2.41L621,518.16c-.07-.14-.14-.28-.2-.42",
    style: {
      fill: "#d25465"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621,518.16l6.55-3.81a8.1,8.1,0,0,0,.73,1.16l-6.55,3.8a8.59,8.59,0,0,1-.73-1.15",
    style: {
      fill: "#d66574"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.74,519.31l6.55-3.8c.1.13.21.26.32.38l-6.55,3.81c-.11-.13-.22-.25-.32-.39",
    style: {
      fill: "#d25465"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.06,519.7l6.55-3.81c.1.12.21.24.32.35l-6.55,3.8c-.11-.11-.22-.22-.32-.34",
    style: {
      fill: "#c72c41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.38,520l6.55-3.8.35.32-6.55,3.81-.35-.33",
    style: {
      fill: "#bd2a3e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.73,520.37l6.55-3.81.36.27-6.55,3.81-.36-.27",
    style: {
      fill: "#b3283b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.09,520.64l6.55-3.81a4,4,0,0,0,.34.23l-6.55,3.8-.34-.22",
    style: {
      fill: "#a92537"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.43,520.86l6.55-3.8h0a2.19,2.19,0,0,0,.3.16L623.76,521l-.3-.16,0,0",
    style: {
      fill: "#9f2334"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.76,521l6.55-3.81.32.14-6.55,3.8-.32-.13",
    style: {
      fill: "#952131"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.08,521.17l6.55-3.8.33.09-6.55,3.81-.33-.1",
    style: {
      fill: "#8b1f2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.41,521.27l6.55-3.81a2.27,2.27,0,0,0,.35,0l-6.55,3.81-.35-.05",
    style: {
      fill: "#811d2a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.76,521.32l6.55-3.81a1.86,1.86,0,0,0,.41,0l-6.55,3.8a1.85,1.85,0,0,1-.41,0",
    style: {
      fill: "#771a27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.17,521.3l6.55-3.8a1.67,1.67,0,0,0,.58-.2l-6.55,3.8a1.49,1.49,0,0,1-.58.2",
    style: {
      fill: "#6d1824"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-18)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M621.19,513.26l6.55-3.81a1.72,1.72,0,0,0-.72.86l-6.55,3.8a1.7,1.7,0,0,1,.72-.85",
    style: {
      fill: "#832623"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.47,514.11l6.55-3.8a2.59,2.59,0,0,0-.14.42l-6.55,3.81a2.41,2.41,0,0,1,.14-.43",
    style: {
      fill: "#8f2926"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.33,514.54l6.55-3.81c0,.12,0,.25-.06.39l-6.55,3.81c0-.14,0-.27.06-.39",
    style: {
      fill: "#9b2d2a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.27,514.93l6.55-3.81c0,.12,0,.25,0,.39l-6.55,3.8c0-.13,0-.26,0-.38",
    style: {
      fill: "#a7302d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.25,515.31l6.55-3.8h0a2.09,2.09,0,0,0,0,.24l-6.55,3.8c0-.08,0-.16,0-.24h0",
    style: {
      fill: "#b33430"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-19)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M651.18,563.53l6.55-3.81c0,.2.09.4.13.6l-6.55,3.81c0-.2-.09-.4-.13-.6",
    style: {
      fill: "#00344f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.31,564.13l6.55-3.81c.43,1.84,1,3.71,1.48,5.53l-6.55,3.81c-.43-1.83-1-3.69-1.48-5.53",
    style: {
      fill: "#003754"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.79,569.66l6.55-3.81.12.57-6.55,3.8-.12-.56",
    style: {
      fill: "#00344f"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-20)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M629.44,522.78,636,519a8.07,8.07,0,0,0-3.36,4l-6.55,3.81a8,8,0,0,1,3.36-4",
    style: {
      fill: "#6d1824"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.08,526.74l6.55-3.81a10.65,10.65,0,0,0-.57,1.81l-6.55,3.8a10.82,10.82,0,0,1,.57-1.8",
    style: {
      fill: "#771a27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.51,528.54l6.55-3.8q-.1.45-.18.93l-6.55,3.81c0-.32.11-.64.18-.94",
    style: {
      fill: "#811d2a"
    }
  })))), /*#__PURE__*/React.createElement("polygon", {
    points: "626.68 519.27 633.23 515.46 637.93 518.18 631.39 521.99 626.68 519.27",
    style: {
      fill: "#ab2638"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.39,522c-3.14.79-5.45,3.42-6.06,7.49,0,.54-.36.87-.2,1.53a29.19,29.19,0,0,0,.64,8.62c.16.88.55,1.79.69,2.66a14.46,14.46,0,0,1-2.41-1.18l-.66-.38-.69-.41-.92-.51c-.18-.1-.32,0-.47,0q-7.75,1.77-15.51,3.5c1.37-3.43,2.78-6.81,4.09-10.3-.86-.54-1.72-1.05-2.58-1.54l-1.43-.82-1.42-.82-1-.6-.27-.16a32.39,32.39,0,0,1-8.38-7c-5.57-6.36-9.49-15.32-9.81-22.63,0-1.41-.08-2.84-.05-4.22l15.59,9a7.13,7.13,0,0,0,3.2,5.32c1.7,1,3.1.26,3.22-1.61l3.46,2a7.13,7.13,0,0,0,3.2,5.32c1.71,1,3.11.25,3.22-1.62l3.46,2a7.12,7.12,0,0,0,3.2,5.32c1.71,1,3.11.26,3.22-1.61Z",
    style: {
      fill: "#6b1823"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-21)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M602.28,484.4l6.55-3.8,21.9,12.63-6.55,3.8q-11-6.3-21.9-12.63",
    style: {
      fill: "#be3733"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-22)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M631.17,525.64l6.55-3.81a6.23,6.23,0,0,1,2.27-.77l-6.55,3.81a6.11,6.11,0,0,0-2.27.77",
    style: {
      fill: "#023"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.44,524.87l6.55-3.81a7.8,7.8,0,0,1,1.61,0l-6.55,3.81a7.8,7.8,0,0,0-1.61,0",
    style: {
      fill: "#002538"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.05,524.82,641.6,521a10,10,0,0,1,1.39.21L636.44,525a8.67,8.67,0,0,0-1.39-.21",
    style: {
      fill: "#00283c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.44,525l6.55-3.81a10.79,10.79,0,0,1,1.28.37l-6.55,3.8a10.71,10.71,0,0,0-1.28-.36",
    style: {
      fill: "#002b41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.72,525.39l6.55-3.8c.4.14.81.31,1.22.5l-6.55,3.81c-.41-.2-.82-.36-1.22-.51",
    style: {
      fill: "#002e46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.94,525.9l6.55-3.81.81.41,4.79,2.75-6.55,3.81c-1.6-.93-3.2-1.84-4.79-2.75-.27-.15-.54-.29-.81-.41",
    style: {
      fill: "#00314a"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-23)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M624.18,497l6.55-3.8.19.11-6.55,3.8-.19-.11",
    style: {
      fill: "#be3733"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.37,497.14l6.55-3.8c.69.4,1.37.85,2.05,1.33l-6.55,3.81c-.68-.49-1.36-.93-2-1.34",
    style: {
      fill: "#ca3b36"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.42,498.48l6.55-3.81q1.08.76,2.13,1.65l-6.55,3.81q-1-.88-2.13-1.65",
    style: {
      fill: "#d63e3a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.55,500.13l6.55-3.81c.7.59,1.39,1.23,2.07,1.9l-6.55,3.8q-1-1-2.07-1.89",
    style: {
      fill: "#e2423d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.62,502l6.55-3.8c.62.61,1.23,1.26,1.82,1.93L632.44,504c-.59-.68-1.2-1.32-1.82-1.94",
    style: {
      fill: "#ee4540"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.44,504l6.55-3.81q.87,1,1.68,2L634.12,506q-.81-1.06-1.68-2",
    style: {
      fill: "#f16864"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.12,506l6.55-3.81c.75,1,1.47,2,2.14,3.1l-6.55,3.8c-.67-1.07-1.39-2.1-2.14-3.09",
    style: {
      fill: "#f37773"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-24)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M637.11,510.41l6.55-3.8c.32.57.63,1.15.93,1.73l-6.55,3.8c-.3-.58-.61-1.16-.93-1.73",
    style: {
      fill: "#f37773"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638,512.14l6.55-3.8c.44.85.85,1.72,1.23,2.58l-6.55,3.81c-.38-.87-.79-1.73-1.23-2.59",
    style: {
      fill: "#f16864"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.27,514.73l6.55-3.81c.34.77.65,1.53.94,2.3l-6.55,3.8c-.29-.76-.6-1.53-.94-2.29",
    style: {
      fill: "#ee4540"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.21,517l6.55-3.8c.28.75.54,1.5.77,2.25l-6.55,3.8c-.23-.74-.49-1.5-.77-2.25",
    style: {
      fill: "#e2423d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641,519.27l6.55-3.8c.22.72.42,1.44.58,2.15l-6.55,3.8c-.16-.71-.36-1.42-.58-2.15",
    style: {
      fill: "#d63e3a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.56,521.42l6.55-3.8c.15.65.28,1.29.38,1.93l-6.55,3.8c-.1-.63-.23-1.27-.38-1.93",
    style: {
      fill: "#ca3b36"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.94,523.35l6.55-3.8c.08.54.15,1.07.2,1.59l-6.55,3.8c0-.52-.11-1.05-.2-1.59",
    style: {
      fill: "#be3733"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M624.18,497a36.2,36.2,0,0,1,12.08,12.06,10.88,10.88,0,0,0,.76,1.15.56.56,0,0,0,.09.17c2.67,4.75,4.63,10,5,14.53-.39-.19-.78-.41-1.17-.64l-.39-.22-.36-.21a15.91,15.91,0,0,0-2.17-1.11,10.31,10.31,0,0,0-6.66-.77l-4.71-2.72a1.77,1.77,0,0,0,0-.23,7.07,7.07,0,0,0-3.21-5.56c-1.78-1-3.22-.2-3.23,1.84,0,.08,0,.16,0,.24l-3.46-2c0-.07,0-.15,0-.23a7.06,7.06,0,0,0-3.21-5.55c-1.78-1-3.23-.21-3.23,1.84a2.09,2.09,0,0,0,0,.24l-3.46-2c0-.08,0-.15,0-.23a7.11,7.11,0,0,0-3.21-5.56c-1.78-1-3.23-.21-3.23,1.84a1.93,1.93,0,0,0,0,.24l-15.59-9a18.71,18.71,0,0,1,1-6.17,11.43,11.43,0,0,1,3.46-5,9.83,9.83,0,0,1,7.23-1.52,17.38,17.38,0,0,1,5.71,1.93Q613.23,490.72,624.18,497Z",
    style: {
      fill: "#802522"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-25)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M636.26,509.09l6.55-3.8c.22.34.42.7.66,1l-6.55,3.8c-.24-.32-.44-.69-.66-1",
    style: {
      fill: "#f37773"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.92,510.12l6.55-3.8.1.11L637,510.24l-.1-.12",
    style: {
      fill: "#f16864"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-26)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M637,510.24l6.55-3.81a.37.37,0,0,0,0,.11l-6.55,3.81-.05-.11",
    style: {
      fill: "#f16864"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.07,510.35l6.55-3.81a.16.16,0,0,0,0,.07l-6.55,3.8,0-.06",
    style: {
      fill: "#f37773"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-27)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M665.76,555.49l6.55-3.81c0,.52,0,1,0,1.52L665.8,557c0-.5,0-1,0-1.52",
    style: {
      fill: "#002e46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.8,557l6.54-3.81a19.92,19.92,0,0,1-.1,2.09l-6.55,3.81c.07-.67.1-1.37.11-2.09",
    style: {
      fill: "#002b41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.69,559.1l6.55-3.81A14,14,0,0,1,672,557l-6.55,3.81a14,14,0,0,0,.27-1.68",
    style: {
      fill: "#00283c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.42,560.78,672,557a10.3,10.3,0,0,1-.49,1.57l-6.55,3.8a9.83,9.83,0,0,0,.49-1.56",
    style: {
      fill: "#002538"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.93,562.34l6.55-3.8a6.65,6.65,0,0,1-.69,1.26,6.14,6.14,0,0,1-2.06,2l-6.55,3.81a6.14,6.14,0,0,0,2.06-2,6.73,6.73,0,0,0,.69-1.27",
    style: {
      fill: "#023"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-28)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M665.67,553.46l6.54-3.81v.05l-6.55,3.81v0",
    style: {
      fill: "#00314a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.67,553.51l6.55-3.81c.07.84.09,1.34.09,2l-6.55,3.81a18.39,18.39,0,0,0-.09-2",
    style: {
      fill: "#002e46"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M644.54,529.06l3.29,1.9,3.2,1.85,2.14,1.23a23.58,23.58,0,0,1,5.54,4.6,30.08,30.08,0,0,1,7,14.82,19.38,19.38,0,0,1,.09,2c.15,3.34-.18,6.18-1.52,8.12-1.7,2.58-4.77,3.46-8.22,2.35a13.51,13.51,0,0,1-3.11-1.45l-.44-.25L652,564l-.84-.47c.46,2.22,1.27,4.49,1.73,6.69.22,1.27-.68,1.69-1.59,1.17a2.67,2.67,0,0,1-.83-.79q-4.51-6.21-9-12.45a2.18,2.18,0,0,0-.8-.7l-.3-.17-.3-.16a2.71,2.71,0,0,1-.35-.24c-4.2-2.46-8.25-7.51-10.38-12.86a23.1,23.1,0,0,1-1.84-9.6c-.13-3.49.82-6.4,2.65-8,2.26-2.08,5.88-2.11,9.59-.07C641.34,527.22,642.94,528.13,644.54,529.06Z",
    style: {
      fill: "#002132"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-29)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M644.54,529.06l6.55-3.81,3.29,1.9,3.2,1.86,2.14,1.23.14.08-6.54,3.81-.15-.09L651,532.81l-3.2-1.85-3.29-1.9",
    style: {
      fill: "#00314a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.32,534.13l6.54-3.81c.47.28.93.58,1.39.9L654.7,535q-.69-.49-1.38-.9",
    style: {
      fill: "#00344f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.7,535l6.55-3.81c.49.35,1,.73,1.45,1.13l-6.55,3.81c-.48-.41-1-.78-1.45-1.13",
    style: {
      fill: "#003754"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.15,536.16l6.55-3.81c.5.42,1,.87,1.47,1.34l-6.55,3.81c-.48-.47-1-.92-1.47-1.34",
    style: {
      fill: "#003a58"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.62,537.5l6.55-3.81c.37.37.73.75,1.09,1.15a1.63,1.63,0,0,1,.17.2l-6.54,3.8-.18-.2c-.36-.39-.72-.77-1.09-1.14",
    style: {
      fill: "#003d5d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.89,538.84l6.54-3.8c.35.39.68.8,1,1.22l-6.55,3.81q-.48-.65-1-1.23",
    style: {
      fill: "#30627c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.88,540.07l6.55-3.81a31.5,31.5,0,0,1,2.89,4.59l-6.55,3.81a31,31,0,0,0-2.89-4.59",
    style: {
      fill: "#447188"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.77,544.66l6.55-3.81c.29.57.57,1.15.82,1.73l-6.55,3.81c-.25-.58-.53-1.16-.82-1.73",
    style: {
      fill: "#30627c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.59,546.39l6.55-3.81c.24.55.46,1.09.67,1.64l-6.55,3.8c-.2-.54-.43-1.09-.67-1.63",
    style: {
      fill: "#003d5d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.26,548l6.55-3.8c.21.56.4,1.12.58,1.68l-6.55,3.81c-.17-.56-.37-1.12-.58-1.69",
    style: {
      fill: "#003a58"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.84,549.71l6.55-3.81c.17.57.32,1.12.45,1.67l-6.55,3.81c-.13-.55-.28-1.11-.45-1.67",
    style: {
      fill: "#003754"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.29,551.38l6.55-3.81c.12.51.22,1,.29,1.52l-6.55,3.8c-.07-.5-.17-1-.29-1.51",
    style: {
      fill: "#00344f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.58,552.89l6.55-3.8c0,.19.06.37.08.56l-6.54,3.81-.09-.57",
    style: {
      fill: "#00314a"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "light",
    id: "light-13",
    "data-name": "light"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "560.89 468.01 626.13 506.03 626.13 631.15 560.89 593.48 560.89 468.01",
    style: {
      opacity: 0.4,
      fill: "url(#linear-gradient-73)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "691.37 593.48 626.13 631.15 626.13 506.03 691.37 468.01 691.37 593.48",
    style: {
      opacity: 0.4,
      fill: "url(#linear-gradient-74)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    className: "block",
    id: "side-block-3",
    "data-name": "side-block"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bolck-13",
    "data-name": "bolck"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "71.58 665.69 136.82 628.02 136.82 632.07 71.58 669.74 71.58 665.69",
    style: {
      fill: "#0f1145"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.06 669.74 202.06 665.69 136.82 628.02 136.82 632.07 202.06 669.74",
    style: {
      fill: "#2e3192"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.82 632.07 202.06 669.74 137.01 708.34 71.58 669.74 136.82 632.07",
    style: {
      fill: "url(#linear-gradient-75)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.82 602.91 28.09 665.69 49.83 678.25 136.82 628.02 223.81 678.25 245.55 665.69 136.82 602.91",
    style: {
      fill: "url(#linear-gradient-76)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.82 728.47 49.83 678.25 71.58 665.69 136.82 703.36 202.06 665.69 223.81 678.25 136.82 728.47",
    style: {
      fill: "url(#linear-gradient-77)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "28.09 690.8 28.09 665.69 136.82 728.47 136.82 753.58 28.09 690.8",
    style: {
      fill: "#20142c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.55 665.69 245.55 690.8 136.82 753.58 136.82 728.47 245.55 665.69",
    style: {
      fill: "url(#linear-gradient-78)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "bolck-14",
    "data-name": "bolck"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "71.58 634.78 136.82 597.11 136.82 601.16 71.58 638.83 71.58 634.78",
    style: {
      fill: "#0f1145"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.06 638.83 202.06 634.78 136.82 597.11 136.82 601.16 202.06 638.83",
    style: {
      fill: "#2e3192"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.82 601.16 202.06 638.83 137.01 677.43 71.58 638.83 136.82 601.16",
    style: {
      fill: "url(#linear-gradient-79)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.82 572 28.09 634.78 49.83 647.34 136.82 597.11 223.81 647.34 245.55 634.78 136.82 572",
    style: {
      fill: "url(#linear-gradient-80)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.82 697.56 49.83 647.34 71.58 634.78 136.82 672.45 202.06 634.78 223.81 647.34 136.82 697.56",
    style: {
      fill: "url(#linear-gradient-81)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "28.09 659.89 28.09 634.78 136.82 697.56 136.82 722.67 28.09 659.89",
    style: {
      fill: "#20142c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.55 634.78 245.55 659.89 136.82 722.67 136.82 697.56 245.55 634.78",
    style: {
      fill: "url(#linear-gradient-82)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "light",
    id: "light-14",
    "data-name": "light"
  }, /*#__PURE__*/React.createElement("image", {
    width: 227,
    height: 80,
    transform: "translate(24 654.67)",
    xlinkHref: "data:image/png;base64,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",
    style: {
      opacity: 0.75,
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30.16 665.32 30.16 661.09 136.82 722.67 136.82 726.9 30.16 665.32",
    style: {
      fill: "url(#linear-gradient-83)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.19 661.25 243.19 665.49 136.82 726.9 136.82 722.67 243.19 661.25",
    style: {
      fill: "url(#linear-gradient-84)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bolck-15",
    "data-name": "bolck"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "71.58 603.75 136.82 566.09 136.82 570.13 71.58 607.8 71.58 603.75",
    style: {
      fill: "#0f1145"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.06 607.8 202.06 603.75 136.82 566.09 136.82 570.13 202.06 607.8",
    style: {
      fill: "#2e3192"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.82 570.13 202.06 607.8 137.01 646.4 71.58 607.8 136.82 570.13",
    style: {
      fill: "url(#linear-gradient-85)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.82 540.98 28.09 603.75 49.83 616.31 136.82 566.09 223.81 616.31 245.55 603.75 136.82 540.98",
    style: {
      fill: "url(#linear-gradient-86)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.82 666.53 49.83 616.31 71.58 603.75 136.82 641.42 202.06 603.75 223.81 616.31 136.82 666.53",
    style: {
      fill: "url(#linear-gradient-87)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "28.09 628.86 28.09 603.75 136.82 666.53 136.82 691.64 28.09 628.86",
    style: {
      fill: "#20142c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.55 603.75 245.55 628.86 136.82 691.64 136.82 666.53 245.55 603.75",
    style: {
      fill: "url(#linear-gradient-88)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "light",
    id: "light-15",
    "data-name": "light"
  }, /*#__PURE__*/React.createElement("image", {
    width: 227,
    height: 80,
    transform: "translate(24 623.67)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOQAAABRCAYAAADCUApLAAAACXBIWXMAAAsSAAALEgHS3X78AAALGElEQVR4Xu2bS09bWRZG1z7HT7B5GQxUp6VSq0epYaRIPar8gJ7W70n4O5Vpzys9LSnDrkGPolJ1EWyeNn77nt0D2wQIBL/xtfeSUEggTqzLuuf7ztlXVBXDMBYD99Q3GIYxP54QUqT3YRjGFHjSpweEFIEjB+89qOPDL773+ZEDTE7DGBoRjo4c7997wMOHnlM3Pn0tp9ztkCKgAh89VD20PeWUsJcPUIogG8G/A7xTsPJpGA8jAu+EDzjevHTwwlNuefaKQFf5oxZ4kerCqwjkjkv3hDxy8E9PuZpmL0pTD2kk6cj6CNJt6LSh0jYxDeNRBN47wMNmEtZS1LppnEsiXtBWRNe1aNJkL9+Cf0XwNtz85VtCCuDgYxrq67Q6G7hUDqIUuAjVBqFdIyM1yr7FVaPDH79GvMHENIzb6fL4OMnaVppUew2XWidq50j5NACaahJaVdL+CtZq8KoFBEDhKyE/JoA1mtVtvC8SdBdx63hVcDVULgndS6JQJZuuQ7UFVx0ggp9uXtQwVod+POVHxycSbGRTpBtrJFwep1uEsIP4TYQMSoRqhRBKiJyQ6V7Adh1edflayCMHr5NUs3nSvojjryh/RbUAJFCp4/QcR5l2OMfTE7OdqlO/bHF42HkoExvGEtOPpz94+CMJWxma3Rw+bBHpLk6KaCgibgs0BTQRPSGE35Hod1q+RL5R5ejXDm97sTVx9/WzQj7l6JAiRDnQAo7vUHKIdlAuUXZJJEoIZSQ6w4VLErkq5906lQ9tvv+lC0cWY40l5nY8zSY5PE9Dfo12c4OE7BBCEe8OUD3EUQTyvUYYLlHaiDtFNIm0HZ+ywtsvr3xPSKDWEFJrAupB0igbqBZw4hF2Ud3t/3qC+hNUS6QSp/jokiQ1yjS5et3hj3cRb0xMY5kYxNNfHJ8+9OLpRm6NVsgTdBvHLkoR3CFwiFBE2UY0hdIEbYP0nNOEQkL5/vqOG/eEbCjrxYh2rQuhjXMtVLo4cSg50DziNkC3QHeAHTxbaLRBQku46IKEr7C3Vefv/+j3y58jbpVWw4gfg2OMd44Xrz2bJCmQIRmt4xO9eOp1H5F9hAPQfZRdxG0gpIEuUEOliZMaITSQ0CaX6MK1wtsbN24J+Vb57b3yMttFaeDlCpUzhE0CGcAjbh3VHJBFJAdsgG6C20LDFupKwBnt1iVRokr7sN8vP1q/NOKKwM+9Y4w3m0nIp2m01vDRBi7a/hJP5RBkH9hF2ATWeimTLkoFoYxznwmhjOeSRLIOdGHv5sgD7q+Qpb3Ay3aHKFtDOMO7DN3II9JFaKBhF5ENIAtsABlUcgibqNvGyw7OWb80loB7PXFwjOFbeWALdQU0FMEdgB4gUkR0G2UdNIFIBFKDUAFXRvR/iPyO0z+JwjmNTp08HXhzJz0+MBjwU4KLP7NsJ/LUtEA6uUcI+ygH/SW5iFJAyCOkUBShAVpB3TkaTlE9QfxngpbwckrkLum0azRp2vmlsdg8cYwhvoCyh4QiYQgfhHJvv0WPCfIZpyVSnXOIriHVgjcRjwsp/eU5l4CdNPX2OlF3gwxbBHZxroi6A0QPQIoId+8IShPRXtRVPUHkTzR8xrkSoX1B5Ct2fmksJrfG3V689mxmk2TIkEyt3znGkH5X1LCHsIP2E6MgKG2UKsIZSgmnJ6grId0ymjwlyAXpqAKNOhTa96d04Cshe3/G+/eOH/AUNpNkNU0y3c/MqV5mFneActhfMXdBN1HWEDyqEeKuCeECkROUYyR8JoQSQc7s/NJYQO6Nu93uifd/5nUfkQLIBkq23xMjhBrKBWgJlc8P/8w36mzuNKHV6Y2e3pURHhYSRIR374Qfv3W3uLWrpLd2ldBM/0WaaKggcnr3bkEZjc4Ickk3VGll61Qabb6na/Oxxnx5ZNzNuzwRWzgtPJ4K8SDRl3iqZ6icIBxPkgofFvLLlx/P00G2cYNpBA4RDlHdx7ltNOQQ8SgRaAPVCuLPHu2XmcQ1XDbhRQf+YzHWmDFT6InQQLSCco64fk+Uk0n3TZ4QcsC9O8nhVhr8Gu3OBq4/mSDuANXvequmFlDZBM2CcxACSOPxfqnnpJIViOocW4w1ZsWQPVGj/gam20XCzk08/WZPnE7yG1LIG4aY3bv1ZjQq9I5JJPt4v+SYoCWCnOL0YpI3YxjfYMieeG9RETKoepDucD1xsr2RUYVkvOVeH+mXnPbF/IzqCUFOJlnuDeNrRumJj9QuoQ5yhdKvXJP1xG8xhpAD4vVGjVUjngvHBELeEIsoYKwUsa1W0xCSOJRlYxWI/+bjlIQcME5MsDE8Y1KW53huykIOGKVf2hieMS7DJLN4DbDMSMgbhuyXNoZnjMxS/mzNWkiW8S5mPCfLnb7mIOSA5cn5xnOwGvsTcxRyQPx3wox5MkzCGvexqMVLWM8g5A2xPSsy5sYIPXGSx6Lm2xO/xXMKyXgx5PmnKYxZM0lPnM1jUfPimYUcMMoFsDG85WWcG/R8HouaFwsi5A1DRhQbw1suhuyJKzDptWhCYhdn5bCb8C0WUMgBFl+WG6spD7HAQg4Y5cItV8FfTsa50a7ORl4MhLxhyGizPFvgS4gddT1BnIRk6H65JIfEy4MNgwxLzIQcME7sid8YVfyxcclRiamQAybpl4s/aBxfhkky9kDBQ8RcyBtG6JfxeRQnpti1mIBlERK7Kz83llamwRIJOcB6y3yxPj9NllDIAbazN1uGSSQ2UTUqSyzkDXb2NX2G7ImrMe42TVZBSMaLVaszHTI8o/TE1Rl3myYrIuQA+4EaD7uhzYsVE/IGi1zDY5F/jqyqkNimxFPYpthzsMJCDhgnji3zY152bPScmJA3jNIvl/Exr2ESgw1WzBoT8muG7JdL9ZjXCO/Zxt1miQn5IMOsFsvwmNckqcDG3WaBCflNptAvF3IsbFnfV/wxIYdiWVaSVVn544sJORpx7loj/N+XphvHDhNyZIZZZRZpN3KS1X0Zdo/jhQk5Not+XjeFnrhU56vxwIScmEWbaBlmBV/lCaTFxoScHrIAM59D9kSb0V1UTMipMk5MnOCpiL1GB7IRlPsX8W/u6Z5oT7EsMibkTBhlI2VMQVK+QjVqkPctuA5wCFwkqSWyM7sBWE+cOSbkbJldhHRyRtJd0ezWCVEH8UI2labT3UB8AZEi3ZlHZGPKmJAzZwabLKolEpRAztBQQaMWiCBujeB2kLCPyuF8NpGMaWJCzo1x+uVjxxDuHNUzCGeIXAJNQPCyRtDe6hjN+5jFmAYm5NwZpV8+clCPNhGtolSAKiJNVAXIApso2714Srr/b85xEMGYBBPy+RiyXz40yhYSIAGhTdA2TjoABJI40qime69L9xlH9YwxMCGflSH75VfD3mwCayBJwPUSpSi9TwLQoRdvn3mY3RgVE3IhGKtf7uLYRHUd6K2Y0AKtoXIFeg6UH+yJdoyxsJiQC8Uo/ZJDYA9hCyUDRKjWEDlHKaNRCZc4sZ4YL0zIxWSIfskBKvs4tlHJ0ns8qkrQM0ROCN2y9cT4YUIuLE/0SwkFxBUIugVkCBpwXOPcORrOSHBBI1StJ8YLE3LheaBf7pCl1cjjXB7RHF2XIhECmmjQ6lyTSFbIJGuU6y3rifHChIwN9x/zyqWokWE9mQJN0AyKhg6Rb5FzTai0e4Pn1hPjhAkZP3r98jc8L194aHnIOjgH/hLx6Tzi7L8Rr44jEzF+mJBxRET6nknv44P0vlBW+GlwHmkXNoaYkLFHpD8Y0P+9XdA4Y0IaxgLhnvoGwzDmx/8B74Kaqa6OK3kAAAAASUVORK5CYII=",
    style: {
      opacity: 0.75,
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30.16 634.29 30.16 630.06 136.82 691.64 136.82 695.87 30.16 634.29",
    style: {
      fill: "url(#linear-gradient-89)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.19 630.23 243.19 634.46 136.82 695.87 136.82 691.64 243.19 630.23",
    style: {
      fill: "url(#linear-gradient-90)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bolck-16",
    "data-name": "bolck"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "71.58 572.79 136.82 535.12 136.82 539.17 71.58 576.83 71.58 572.79",
    style: {
      fill: "#0f1145"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.06 576.83 202.06 572.79 136.82 535.12 136.82 539.17 202.06 576.83",
    style: {
      fill: "#2e3192"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.82 539.17 202.06 576.83 137.01 615.43 71.58 576.83 136.82 539.17",
    style: {
      fill: "url(#linear-gradient-91)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.82 510.01 28.09 572.79 49.83 585.34 136.82 535.12 223.81 585.34 245.55 572.79 136.82 510.01",
    style: {
      fill: "url(#linear-gradient-92)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.82 635.56 49.83 585.34 71.58 572.79 136.82 610.45 202.06 572.79 223.81 585.34 136.82 635.56",
    style: {
      fill: "url(#linear-gradient-93)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "28.09 597.9 28.09 572.79 136.82 635.56 136.82 660.67 28.09 597.9",
    style: {
      fill: "#20142c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.55 572.79 245.55 597.9 136.82 660.67 136.82 635.56 245.55 572.79",
    style: {
      fill: "url(#linear-gradient-94)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "light",
    id: "light-16",
    "data-name": "light"
  }, /*#__PURE__*/React.createElement("image", {
    width: 227,
    height: 80,
    transform: "translate(24 592.67)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOQAAABRCAYAAADCUApLAAAACXBIWXMAAAsSAAALEgHS3X78AAALlklEQVR4Xu2bS09bWRZG1z73+gU2mIeBdKelGvQoNSyppB4VP6Cn+T1J/k5l2vNKTUuqYfege1IqlSrB5mmD3+fsHlzbSQiEa2OMr9lLQgoEbLDvumd/Z+8jqophGMuBu+sbDMNYHHcIKZJ8GIYxB+706QYhReCNg7cRqOPdT1Hy7zcOMDkNIy0iQuKMAyJ4lzg18elLOeXzDCkCKvBrBK0I+hGNvFCrBKh7KHn4OcBrBQufhvEVBN46/kPEi+cRrDuIBYbKH1eB5/khfOdBPnPpmpBvHPwzotEqUPMF2qGA5BylyEOhD4M+NPsmpmHcxieL2vv3OUrlPDlfYD3K0c05igxpDfp06VKr9OBfHl6FyU9/IuRoaf21AO11eoMNXL4MPg/Oo9oh9K8oyhWNqMdFZ8Afv3gOMTENAxF4LfCD4zdiNkp5tinR82VcKDMclkCEWLqE0KIQXcDaFXzXAwKg8IWQv8bAGt3WFlG0R9BdxK0TqYK7QuWcMDzHhxalQhtaPbgYAB5eTh7UMJ4OIxHf4Xj+fcRmKUeRIrn8OlGoIn6bIFsga6CByDXpDxqIHFEcnsFWG74b8qWQbxx8n6NVqlCI9nD8DeVvqO4AMSptnJ7iaNAPp0QkYvbzbdrnPZ49G9xUExvGCpPkRIhgMweVAp3eGpHfwOW3CGEPkT1Ud3CuCNLDhwaE3xH/O72oTqXT4s0vA14lZWv8+eOXhEreMSBP8GXQHRx/QSkjOkA5R9kljusIDcSf4MI5cbnF6bBN812fb34awhsrY40V5tOcWMqxVi2Q768R9SpAFXU7aNgDDkD2EKmiRBCaCEOiuEHQHNJ3/FYSXn185GtCAlcdIb8moBFOCigbiO4QiIEayi4aagQ9QqIPqNbJx8dE/pwcVzTocvH9gD9eew5NTGOVGOfEnxy/vUty4kZ5jThUcFEViXYQakjYI8g+6B6qWyBF0AHiBjiN8EEgVoiVby4/c+OakB1lfc/TvxpC6IPrgQyBCKEMUgHdxLGFum00bBNJFfUbxFrH+TPiqEmt2ubv/xjlyx89n4RWw8ge45z4epQTybFDkZxfJ4qreN1F3R7oPiL7KDWcbqOyQaCIw6P0QHsobZxrE4Z9yvEQLhVeTdz4RMhXyn/eKi9KQ5QOkVygcoJoFZUSSjyRUnUNkQqqm8AmuCoaqqirAyf0e+f4uEX/2Shf/mr50sgqAj8mOfHwek70SU6M3AGqz0D3gR3EbaCUkipThyiXiByjegQ0kHBBPtcGhlCbtDzg+gpZrwVe9Af40hVueEqQEi7EiPMgfYQaKptAEdUq4opoWEdkA3VbRLKNc5YvjRUgbU50B6AHiOwhsoWyDhqBeEQuCdpEpIHyJ8LviP6JD6d0Bm0qDODws+rxUyGVw58DvBzQ+7PNWnzCwIO4AUob0UtUL1HZx7ktNJQRCiDboCXQTTTavjVfbq9dwnkXXg7ghZWxxpIyZU4U9lDZQagAeZJruo2EJsop0CBwhOh7vP+Ai+oUwjkF34H8pN0xefYvR+d+dFCOYbtAu79O7Ddxbpug+4g7QPUviOwjupOslloC5yAEkA6iSamreoTIn2j4gHN1gp6SzzXBt3lvbRJj2bijn+h1Fyd7qD9Irn+3i4RtkKQ8FQSlj9JCOEGp4/QIdXVk2EBzxwQ5o+Cb0GnDTv/6lA58IWTyNd6+dXxLxIvNHERFulImkio+/vKXUr+DyAZICSFC1SPukhDOEDlCeY/wnqB1ghzj9IxhaNErtWl2+nzD0MbwjEcmRT/xhsVIKKIagQwRrlDOQOuofEDCB0KoE+TkY8++02Zzuwu9QXLNfy4j3CwkiAivXws//OA4fB5x+r8ChdIasavgNFm29fqyrbuI2wAtjh6ki4YmwvFIzA+oHhHkiEiO8e6cQf+KLl0bwzMeh2tzp5Oc6Cp4qjjdwbk91B0gPEP1k7gmEYpHaINcoCSbNsL7j1Vh/wwfNaeZartZyI//vXS/sGHcnxvmTgudpVhw7hBywoKWdBvDMx6c0bX8bQR/5KBapDss35oTFxzJ0grJw4ZeGqg/Icj5ff4Yw7ida9Xes2oBojX6gw2cbN+6qCx403IKIcfMstyTbAsLeRQFOogm28LiGqgeoXJE0Pp9lnvD+JKvXK9BtnDjhYRnt8YutINqE4lO0DCKXtGHz67XYjxq6z0fwL9njl0zCDlmmnypoyFbRo1TRo1TOqBNVE9QsXxpzJE0Fd1o1E04QHUf5ZacKMeLqujuIeSElPmSZ4juI7IzKWPRCPCWL405M8U1KfsIu6CbKGu358TFXJPzEJJ0dyPZGwm5j4YaQjJ8i+VLY17cp2rTGBGP0r09Jz581TYnIcfMIV9Oylh3+tD1urEqLOi6W8C+xpyFHPPQd6r57GgZWWf1KrMHEnLCA9Ty8+v5GJlmimsrO3sXDy0k6e5iaXe75jsVYWSR+1Rfy7+7vwAhx8yhH2RjeE+YOeTEDPS/FyjkmBknJmwM74mSpsJanQmxRxBygkw1U5jhF9mYmZQ5cXVu3o8pJE+lDDGmZZqcuFrx5pGFHDPNG5C9oG6kZZYb9GKORS2KJRFyQsoSJVtb2UYqposwCz4WtSiWTUhSh/gMNXuNrzHjJt+Cj0UtiiUUcsws5ctyjkMZNzGHNtgCj0UtiiUWcsx98mWaMTzLl4slTQWUdlBkcceiFkUGhJwwRb5MO4Zn+XLB2Ht4B1kSEru7ZhWrctKSMSHHWP7IBrYPMC0ZFXKM7dAtJ2kqGdspv4mMCznBeljLwxQ50XrJ11kVIZmtPFqtKY/H5T450aatxqyQkGOmuTBWaw7ycZjlRmjzyLexgkJOSFk6rc5JgUdguqhgJ3buZJWFJPXmgl00UzLjZprd7O5kxYUcY2XVfJhDu8niwFd5IkKOmSZf2sbDR9JUGmkHMmzD7Gs8MSEnpMyXtjXPVK9V2nE3ayndxlMVknR3/afcvL5PNZFm3M2GLm7iCQs5Zg75cqXGuxb0ethY4o2YkBMeekVY9nxpFcMyYEJ+yQNkpqXPl1P8zU8+Uz8oJuSNpFkt0u4qLvMxr/tUBU951/nhMCG/yhz6bkt5zGsOOdH6sg+CCZmKGSdTlu6YV5qV3yaXHhMTcjpkqtnN5TrmlTIn2rjbY2JCTs0s5d5jHvOaJifauNtjY0LOzLJf6Fm7cRhgQs6DZSwFs1xaP2lMyLmwNJslknxkffPp6WJCzpVZysR7tBNqnQGUPByG5PnfJc/7TSnP1Sq0Z54eJuSDME2+nLHhno+atHyHStSDggfguBGzu1GA/DqDVRpgeDqYkA9Lynw5w0iakxNy7oLusE0x1wegO8jjpJysilJbwRG/lceEfHBS5svphrbrCHWG4ZRILhj4XvJUFJFoExftInqAruIQ/GpjQi6MOeRLoQPSRMMZIscQTvB6gXMdAAIlhCqwi0jt5p9flWNiq4kJuXDuky9HKxx0CXqJcAG0IHRRpwhFkArCJlBhvju4xgIwIR+PKfLltQwIMRBA+0AXZQAoSIyTPKp5BIfasaisYUI+Kmny5U27pLIJlEjEJJFHxhnPAwOgg3Bx6y6t5cSlxIRcCmY45iWyA1RQLSI4EA/0QK9QuUD05M4+puXEpcOEXCqmPOaluotIBciBepRLRE5RGpYTs4kJuZx8fRY1J3sE3UeoIbpJkAKoR6RJ0BNEjgjDhuXE7GFCLi13tUncNiLbhLABWhiVrJc4d4qGE2LO6ISW5cRsYUIuPbe0SZyU8VIh79ZAcuACSofe4JI416SYu6LR7llOzBYmZHb4vE3S1ALxWgEX5SmGCILSCQN81KPsutDsJ4PnlhOzhAmZKT5pkxy+dHARwWYELQenwF89v516Tv7r+e69NxGzhwmZSUR481p48UKo1YTD8dcbCi+VJCPaG5tBTMjMI5K4J6PP7Q3NMiakYSwR7q5vMAxjcfwf0fqIKshX3vgAAAAASUVORK5CYII=",
    style: {
      opacity: 0.75,
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30.16 603.33 30.16 599.1 136.82 660.67 136.82 664.91 30.16 603.33",
    style: {
      fill: "url(#linear-gradient-95)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.19 599.26 243.19 603.49 136.82 664.91 136.82 660.67 243.19 599.26",
    style: {
      fill: "url(#linear-gradient-96)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "glow-3",
    "data-name": "glow"
  }, /*#__PURE__*/React.createElement("g", {
    className: "light",
    id: "light-17",
    "data-name": "light"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "71.58 572.79 71.58 447.32 136.82 409.65 136.82 535.12 71.58 572.79",
    style: {
      opacity: 0.4,
      fill: "url(#linear-gradient-97)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.06 572.79 202.06 447.32 136.82 409.65 136.82 535.12 202.06 572.79",
    style: {
      opacity: 0.4,
      fill: "url(#linear-gradient-98)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "float-up-higher",
    id: "floater-3",
    "data-name": "floater"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-30)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.71,505l10-5.8a2,2,0,0,1,.59-.22c3.17-.69,6.34-1.37,9.52-2,1.29-.26,2.6-.47,3.93-.66h0l-10,5.8h0c-1.33.18-2.64.39-3.93.65-3.18.65-6.35,1.34-9.52,2a1.77,1.77,0,0,0-.59.23",
    style: {
      fill: "#023"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.75,502.05l10-5.8a4.18,4.18,0,0,1,.87,0l-10,5.8a4.18,4.18,0,0,0-.87,0",
    style: {
      fill: "#002538"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.62,502l10-5.8a4.3,4.3,0,0,1,.69.11l-10,5.79a4.37,4.37,0,0,0-.7-.1",
    style: {
      fill: "#00283c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.32,502.12l10-5.79a5.25,5.25,0,0,1,.65.18l-10,5.8a5.74,5.74,0,0,0-.64-.19",
    style: {
      fill: "#002b41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,502.31l10-5.8.5.2.07,0-10,5.79-.07,0a4,4,0,0,0-.5-.2",
    style: {
      fill: "#002e46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.53,502.54l10-5.79c.08,0,.16.08.24.12l-10,5.79-.24-.12",
    style: {
      fill: "#00314a"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-31)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.35,518.4l10-5.8,22.27-4.83-10,5.79-22.27,4.84",
    style: {
      fill: "#701717"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-32)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.77,502.66l10-5.79h0l-10,5.8,0,0",
    style: {
      fill: "#00314a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.79,502.68l10-5.8.22.15-10,5.79a1.64,1.64,0,0,0-.22-.14",
    style: {
      fill: "#00344f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,502.82,130,497l.21.16-10,5.79-.21-.16",
    style: {
      fill: "#003754"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.22,503l10-5.79a1.62,1.62,0,0,1,.2.18l-10,5.79-.2-.18",
    style: {
      fill: "#003a58"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.42,503.16l10-5.79.18.19-10,5.8-.18-.2",
    style: {
      fill: "#003d5d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.6,503.36l10-5.8.18.22c1.62,2.11,3.26,4.18,4.89,6.27l0,0-10,5.79,0,0c-1.63-2.09-3.27-4.16-4.89-6.27l-.18-.21",
    style: {
      fill: "#30627c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.69,509.87l10-5.79c.09.11.17.23.29.39l-10,5.79-.29-.39",
    style: {
      fill: "#447188"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M119.77,502.66a3.65,3.65,0,0,1,1,.91c1.62,2.11,3.26,4.18,4.89,6.27l.31.42q-11.45,2.6-22.89,5.16c0-.17-.07-.27-.09-.37-.35-1.83-.71-3.67-1-5.5-.14-.72-.26-1.43-.39-2.15l.06-.92a5.71,5.71,0,0,1,.21-.58,2.16,2.16,0,0,1,1.47-1.18c3.17-.68,6.34-1.37,9.52-2,1.29-.26,2.6-.47,3.93-.65a4.86,4.86,0,0,1,2.71.46A3,3,0,0,1,119.77,502.66Z",
    style: {
      fill: "#002132"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-33)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.62,513.56l10-5.79.19.26-10,5.79-.19-.26",
    style: {
      fill: "#da6262"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.81,513.82l10-5.79c.35.45.71.89,1.07,1.3l-10,5.8c-.36-.42-.72-.85-1.07-1.31",
    style: {
      fill: "#d65252"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.88,515.13l10-5.8c.34.38.68.75,1,1.1l.16.16-10,5.8-.16-.17c-.35-.35-.69-.71-1-1.09",
    style: {
      fill: "#cc2929"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.07,516.39l10-5.8c.34.34.69.66,1,1l-10,5.8c-.35-.3-.7-.61-1-1",
    style: {
      fill: "#c22727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.11,517.34l10-5.8c.3.26.6.49.91.71L132,518c-.31-.21-.61-.45-.91-.7",
    style: {
      fill: "#b82525"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,518l10-5.79c.26.19.53.36.8.52l-10,5.79a7.79,7.79,0,0,1-.8-.52",
    style: {
      fill: "#ad2323"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.82,518.56l10-5.79.07,0,.33.19.31.15-10,5.79-.31-.15-.33-.18-.07-.05",
    style: {
      fill: "#a32121"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.53,518.94l10-5.79c.21.1.42.18.62.26l-10,5.79a6.33,6.33,0,0,1-.62-.26",
    style: {
      fill: "#991f1f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.15,519.2l10-5.79a5.1,5.1,0,0,0,.61.17l-10,5.8-.62-.18",
    style: {
      fill: "#8f1d1d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.77,519.38l10-5.8a5.13,5.13,0,0,0,.65.1l-10,5.79a3.65,3.65,0,0,1-.64-.09",
    style: {
      fill: "#851b1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.41,519.47l10-5.79a3.19,3.19,0,0,0,.76,0l-10,5.8a3.82,3.82,0,0,1-.76,0",
    style: {
      fill: "#7a1919"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.17,519.45l10-5.8a3.4,3.4,0,0,0,1.12-.35l.15-.09-10,5.79-.16.09a3.59,3.59,0,0,1-1.12.36",
    style: {
      fill: "#701717"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-34)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.91,448.48l10-5.79a1.44,1.44,0,0,1,.4-.18,4.44,4.44,0,0,1,.89-.21l-10,5.8a5.23,5.23,0,0,0-.89.2,1.81,1.81,0,0,0-.4.18",
    style: {
      fill: "#023"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.2,448.1l10-5.8a6,6,0,0,1,1.28,0l-10,5.8a6,6,0,0,0-1.28,0",
    style: {
      fill: "#002538"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.48,448.06l10-5.8a8.81,8.81,0,0,1,1.19.18l-10,5.8a7.47,7.47,0,0,0-1.19-.18",
    style: {
      fill: "#00283c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.67,448.24l10-5.8c.21.05.42.1.64.17l.25.08-10,5.79-.25-.08c-.22-.06-.43-.12-.64-.16",
    style: {
      fill: "#002b41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.56,448.48l10-5.79.93.36-10,5.79c-.31-.11-.62-.25-.93-.36",
    style: {
      fill: "#002e46"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-35)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.69,486.85l10-5.79c-.17,1.48-.3,3-.48,4.44-.22,1.82-.42,3.65-.71,5.43l-.12.73c-.35,2.11-.72,4.2-1.14,6.25-.12.57-.24,1.14-.37,1.71l-10,5.79c.13-.56.25-1.13.37-1.71.42-2.05.79-4.14,1.14-6.25l.12-.73c.29-1.77.49-3.61.71-5.43.18-1.47.32-3,.48-4.44",
    style: {
      fill: "#851b1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.87,505.41l10-5.79c-.43,1.88-.92,3.69-1.46,5.47l-.18.61-.16.49c-.55,1.71-1.14,3.36-1.81,4.95l-10,5.79c.67-1.58,1.26-3.24,1.81-4.94.05-.17.11-.33.16-.5l.18-.6c.54-1.78,1-3.6,1.46-5.48",
    style: {
      fill: "#7a1919"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.26,516.93l10-5.79a43.29,43.29,0,0,1-1.87,3.94,22.44,22.44,0,0,1-3.79,5.28,79.76,79.76,0,0,1-8.71,7.47c-1.34,1-2.72,1.89-4.14,2.72l-10,5.79a48.35,48.35,0,0,0,4.14-2.72,78.67,78.67,0,0,0,8.71-7.47,22.24,22.24,0,0,0,3.79-5.28,42.06,42.06,0,0,0,1.87-3.94",
    style: {
      fill: "#701717"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-36)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.77,486.44l10-5.79s0,.05,0,.07l-10,5.8s0-.06,0-.08",
    style: {
      fill: "#851b1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.75,486.52l10-5.8,0,.11-10,5.79,0-.1",
    style: {
      fill: "#7a1919"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.73,486.62l10-5.79a1.55,1.55,0,0,0,0,.21l-10,5.8a1.43,1.43,0,0,1,0-.22",
    style: {
      fill: "#851b1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.69,486.84l10-5.8v0l-10,5.79h0",
    style: {
      fill: "#8f1d1d"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-37)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.49,448.84l10-5.79,1,.67-10,5.79-1-.67",
    style: {
      fill: "#00344f"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M151.49,448.84l1,.67.23.3c0,.09,0,.18,0,.27q-.68,9.12-1.37,18.24c-.19,2.43-.42,4.83-.65,7.24-.08.8-.21,1.56-.34,2.33-.06.39-.26.47-.64.25a5.48,5.48,0,0,1-.79-.56,13.41,13.41,0,0,1-1.73-1.86,14.51,14.51,0,0,1-1.83-2.67c-.52-1-1-2.06-1.5-3.1a1.13,1.13,0,0,1-.14-.67c.46-6.46.93-12.92,1.37-19.39a1.56,1.56,0,0,1,.61-1.3,2.1,2.1,0,0,1,.58-.29,6.7,6.7,0,0,1,4,.1C150.7,448.51,151.1,448.7,151.49,448.84Z",
    style: {
      fill: "#002132"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-38)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.76,449.81l10-5.8c0,.1,0,.19,0,.28-.46,6.08-.9,12.17-1.37,18.24-.19,2.43-.42,4.83-.65,7.23,0,0,0,.09,0,.13l-10,5.79s0-.08,0-.12c.23-2.41.46-4.81.65-7.24q.7-9.1,1.37-18.24c0-.09,0-.18,0-.27",
    style: {
      fill: "#002b41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.7,475.68l10-5.79c-.08.76-.2,1.48-.32,2.2,0,0,0,.05,0,.07l-10,5.79a.13.13,0,0,0,0-.06c.12-.73.25-1.45.32-2.21",
    style: {
      fill: "#00283c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.37,478l10-5.79a.56.56,0,0,1,0,.12l-10,5.79a.34.34,0,0,0,0-.12",
    style: {
      fill: "#002538"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.33,478.07l10-5.79a.34.34,0,0,1-.12.16l-10,5.79a.3.3,0,0,0,.12-.16",
    style: {
      fill: "#023"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-39)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "152.53 449.51 162.5 443.72 162.5 443.73 152.53 449.52 152.53 449.51",
    style: {
      fill: "#447188"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.53,449.52l10-5.79.23.28-10,5.8-.23-.29",
    style: {
      fill: "#30627c"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-40)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.11,451.32l10-5.8.23.13-10,5.79-.23-.12",
    style: {
      fill: "#a32121"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.34,451.44l10-5.79.16.1-10,5.8-.17-.11",
    style: {
      fill: "#ad2323"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "155.5 451.55 165.47 445.75 165.48 445.76 155.51 451.55 155.5 451.55",
    style: {
      fill: "#b82525"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-41)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174,483.13l10-5.8c-.07,1.11-.13,2.21-.19,3.32l-10,5.79c.06-1.11.13-2.21.19-3.31",
    style: {
      fill: "#8f1d1d"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-42)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.52,451.55l10-5.79c1,.71,1.94,1.47,2.89,2.27l-10,5.79c-1-.8-1.91-1.55-2.88-2.27",
    style: {
      fill: "#b82525"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.4,453.82l10-5.79c.55.46,1.1.94,1.64,1.44s1,.92,1.46,1.4l-10,5.8c-.48-.48-1-.95-1.46-1.4s-1.09-1-1.64-1.45",
    style: {
      fill: "#c22727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.5,456.67l10-5.8c.88.87,1.73,1.77,2.56,2.71l-10,5.8c-.83-.95-1.68-1.85-2.56-2.71",
    style: {
      fill: "#cc2929"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.06,459.38l10-5.8c.71.82,1.41,1.66,2.09,2.54l-10,5.8c-.68-.88-1.37-1.73-2.09-2.54",
    style: {
      fill: "#d65252"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.15,461.92l10-5.8c.49.64,1,1.3,1.43,2a41.78,41.78,0,0,1,2.66,4.45l-10,5.8a40.81,40.81,0,0,0-2.66-4.45c-.47-.68-.94-1.34-1.43-2",
    style: {
      fill: "#da6262"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.24,468.35l10-5.8c.33.64.64,1.29.92,1.93l-10,5.79c-.28-.64-.59-1.28-.92-1.92",
    style: {
      fill: "#d65252"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.16,470.27l10-5.79c.27.59.51,1.19.73,1.79l-10,5.79c-.23-.6-.47-1.19-.74-1.79",
    style: {
      fill: "#cc2929"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.9,472.06l10-5.79c.24.64.46,1.27.66,1.91l-10,5.8c-.2-.64-.41-1.28-.65-1.92",
    style: {
      fill: "#c22727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.55,474l10-5.8c.21.69.39,1.38.55,2.07l-10,5.79c-.16-.69-.35-1.38-.56-2.06",
    style: {
      fill: "#b82525"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.11,476l10-5.79c.17.72.31,1.44.43,2.16l-10,5.79q-.18-1.08-.42-2.16",
    style: {
      fill: "#ad2323"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.53,478.2l10-5.79c.11.75.2,1.51.26,2.26l-10,5.8c-.07-.76-.15-1.51-.27-2.27",
    style: {
      fill: "#a32121"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.8,480.47l10-5.8c0,.31.05.61.06.91,0,.58.07,1.17.11,1.75l-10,5.8c0-.59-.08-1.18-.11-1.76,0-.3,0-.6,0-.9",
    style: {
      fill: "#991f1f"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M155.11,451.32a3,3,0,0,1,.41.23,52.65,52.65,0,0,1,4.52,3.72,50.74,50.74,0,0,1,7.54,8.63,33.42,33.42,0,0,1,6.27,17.47c0,.58.07,1.17.11,1.76-.06,1.1-.13,2.2-.19,3.31a3,3,0,0,0-.08.41c-.16,1.48-.3,3-.48,4.44-.22,1.82-.42,3.66-.71,5.43l-.12.73c-.35,2.11-.72,4.2-1.14,6.25-.5,2.49-1.13,4.87-1.83,7.19l-.18.6c0,.17-.11.33-.16.5a51.33,51.33,0,0,1-3.68,8.88,22.24,22.24,0,0,1-3.79,5.28,78.67,78.67,0,0,1-8.71,7.47,43.27,43.27,0,0,1-6.89,4.17c-.85.4-1.71.77-2.59,1.1a24.43,24.43,0,0,1-8,1.66,20.86,20.86,0,0,1-8.45-1.48,17.12,17.12,0,0,1-2.18-1c-.26-.15-.52-.31-.78-.49-1.11-.76-2.21-1.45-3.32-2.15a6.81,6.81,0,0,1-.88-.69c-2.91-2.73-5.75-5.64-8.49-8.78a86.42,86.42,0,0,1-5.64-7.09c-.1-.14-.19-.28-.31-.44l22.27-4.84a24.11,24.11,0,0,0,2.29,2.66,14.34,14.34,0,0,0,3,2.39l.33.18a4.21,4.21,0,0,0,4.07.3,7.1,7.1,0,0,0,1.64-1.32,71.62,71.62,0,0,0,5.19-6c4.06-5.08,8-10.36,11.82-15.71a2.8,2.8,0,0,0,.31-.57,9.88,9.88,0,0,0,.81-3.43,12.94,12.94,0,0,0-.7-5.09,18.53,18.53,0,0,0-2.69-5.06c-.35-.47-.7-.91-1.06-1.38,0-.14,0-.29,0-.42l.27-3.22.81-9.34.51-6.05.84-9.79C155.08,451.57,155.09,451.44,155.11,451.32Z",
    style: {
      fill: "#6d1616"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "light",
    id: "light-18",
    "data-name": "light"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "71.58 447.32 136.82 485.34 136.82 610.45 71.58 572.79 71.58 447.32",
    style: {
      opacity: 0.4,
      fill: "url(#linear-gradient-99)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.06 572.79 136.82 610.45 136.82 485.34 202.06 447.32 202.06 572.79",
    style: {
      opacity: 0.4,
      fill: "url(#linear-gradient-100)"
    }
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/Support.3c599d17.svg";
export { ForwardRef as ReactComponent };